import React, { useEffect, useState, useRef, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-balham.css";
import "ag-grid-enterprise";
import IntlMessages from "util/IntlMessages";
import {
  Button,
  Input,
  Modal,
  Radio,
  Popover,
  Form,
  Badge,
  Tooltip,
  Tabs,
  InputNumber,
  Alert,
  Divider,
  Spin,
} from "antd";
import {
  MailOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  DownloadOutlined,
  LeftOutlined,
} from "@ant-design/icons";
import AdminNotifications from "components/AdminNotifications";
import ReportActionButtons from "components/ReportActionButtons";
import {
  monthArray,
  showMessage,
  yearList,
  formulationType,
  currencyList,
  statusArray,
  countryList,
} from "../../../helpers";
import {
  approveSalesReportData,
  getAdminApiSalesData,
  getAdminFdfSalesData,
  getAdminDiagnosticsSalesData,
  getAdminProductsToBeVerified,
  getApiSalesData,
  getFdfSalesData,
  getDiagnosticsSalesData,
  partnerMarkSalesReportMessageRead,
  postAdminApiSalesData,
  postAdminFdfSalesData,
  postAdminDiagnosticsSalesData,
  postApiSalesReportData,
  postFdfSalesReportData,
  postDiagnosticsSalesReportData,
  submitSalesReportData,
} from "../../../appRedux/actions/SalesReport";
import { isEmpty, findIndex, has } from "lodash";
import moment from "moment";
import { getUserInfo } from "../../../helpers";
import { SearchSelect } from "./searchSelect";
import { useNavigate, useParams } from "react-router-dom";
import "./sales-report.css";
import { initRowData, suppressEnter } from "./sales-report-util";
import ProductVerificationModal from "./productVerificationModal";
import { CountrySelect } from "./countrySelect";
import { ProductSelect } from "./productSelect";
import { getRole } from "../../../helpers";
import { royalty_countries_product } from "../../../constants/app.constants.js";
import {
  getSalesRequestData,
  // deleteSalesRequestData,
} from "../../../appRedux/actions";
import { getPartnersProductList } from "../../../appRedux/reducers/RoyaltySalesSlice";
import { getPartnerProducts } from "../../../services/InteractiveMap";
import PopupCellRenderer from "./popupRequestId";
import { getProductList } from "../../../services/AdminProduct.js";
import LoadingBar from "components/LoadingBar";
import { useGetRoyaltySalesRequestQuery } from "../../../appRedux/api/salesReportApi";

const confirm = Modal.confirm;
const TabPane = Tabs.TabPane;

const SalesReport = (props) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [isActionLoading, setIsActionLoading] = useState(false);
  const [isDataReady, setIsDataReady] = useState(false);
  const [isFdfInitialized, setIsFdfInitialized] = useState(false);
  const [areApiRowsSelected, setAreApiRowsSelected] = useState(false);
  const [areFdfRowsSelected, setAreFdfRowsSelected] = useState(false);
  const [deleteApiIds, setDeleteApiIds] = useState([]);
  const [deleteFdfIds, setDeleteFdfIds] = useState([]);
  const [addApiRowNumber, setAddApiRowNumber] = useState(0);
  const [addFdfRowNumber, setAddFdfRowNumber] = useState(0);

  const [isUserAdmin, setIsUserAdmin] = useState(false);
  const [isUserStaff, setIsUserStaff] = useState(false);
  const isUserDiagnosticAdmin = getRole() === "DIAGNOSTIC_ADMIN";
  const isUserDiagnosticReviewer = getRole() === "DIAGNOSTIC_REVIEWER";
  const [showVerificationModal, setShowVerificationModal] = useState(false);
  const [pendingProducts, setPendingProducts] = useState(0);
  const [partnerId, setPartnerId] = useState(null);
  const [reportDetails, setReportDetails] = useState({});

  const [apiGridApi, setApiGridApi] = useState(null);
  const [fdfGridApi, setFdfGridApi] = useState(null);
  const [diagnosticsGridApi, setDiagnosticsGridApi] = useState(null);
  const [ApiRowData, setApiRowData] = useState([]);
  const [FdfRowData, setFdfRowData] = useState([]);
  const [DiagnosticsRowData, setDiagnosticsRowData] = useState([]);
  const [ApiColumnDefs, setApiColumnDefs] = useState([]);
  const [FdfColumnDefs, setFdfColumnDefs] = useState([]);
  const [DiagnosticsColumnDefs, setDiagnosticsColumnDefs] = useState([]);

  const [messageCount, setMessageCount] = useState(0);
  const [countryOrder, setCountryOrder] = useState([]);
  const [countryDropdown, setCountryDropdown] = useState([]);
  const [apiProductOrder, setApiProductOrder] = useState([]);
  const [apiProductDropdown, setApiProductDropdown] = useState([]);
  const [fdfProductOrder, setFdfProductOrder] = useState([]);
  const [fdfProductDropdown, setFdfProductDropdown] = useState([]);
  const [diagnosticsProductOrder, setDiagnosticsProductOrder] = useState([]);
  const [diagnosticsProductDropdown, setDiagnosticsProductDropdown] = useState([]);
  const [addDiagnosticsRowNumber, setAddDiagnosticsRowNumber] = useState(0);
  const [areDiagnosticsRowsSelected, setAreDiagnosticsRowsSelected] = useState(false);
  const [deleteDiagnosticsIds, setDeleteDiagnosticsIds] = useState([]);
  const [yearDropdown, setYearDropdown] = useState([]);
  const [monthDropdown, setMonthDropdown] = useState([]);
  const [tabKey, setTabKey] = useState(() => ((getRole() === "DIAGNOSTIC_ADMIN" || getRole() === "DIAGNOSTIC_REVIEWER") ? "diagnostics" : "api"));
  const [isUserDetails, setUserDetails] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [quarterDropdown, setQuarterDropdown] = useState([]);
  const [quarterDropdownCurrent, setQuarterDropdownCurrent] =
    useState("Loading...");
  const [isHistoricQuarter, setIsHistoricQuarter] = useState(false);

  const { apiSalesList, fdfSalesList, diagnosticsSalesList, fdfRequestError } =
    useSelector(({ salesReport }) => salesReport);
  const { partnersProductList } = useSelector(
    ({ royaltySales }) => royaltySales
  );
  const [partnerProductsLoaded, setPartnerProductsLoaded] = useState(false);
  const [viewedPartnerProducts, setViewedPartnerProducts] = useState([]);
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  useEffect(() => {
    setUserDetails(() => {
      return getUserInfo();
    });
  }, []);
  // Fetch partner's product list to determine which tabs to show
  // Partner view: use getPartnersProductList (logged-in partner). Admin view: use getPartnerProducts(id).
  useEffect(() => {
    if (!id) {
      dispatch(getPartnersProductList())
        .unwrap()
        .then(() => setPartnerProductsLoaded(true))
        .catch(() => setPartnerProductsLoaded(true));
    } else {
      getPartnerProducts(id, true)
        .then((res) => {
          const products = res?.results || [];
          setViewedPartnerProducts(products);
          setPartnerProductsLoaded(true);
        })
        .catch(() => setPartnerProductsLoaded(true));
    }
  }, [id, dispatch]);
  // Products to use for tab visibility: partner view = partnersProductList, admin view = viewedPartnerProducts
  const productsForTabs = id ? viewedPartnerProducts : partnersProductList;
  const hasProductData = Array.isArray(productsForTabs) && productsForTabs.length > 0;
  const hasApiProducts = hasProductData && productsForTabs.some((p) => p?.category === "API");
  const hasFdfProducts = hasProductData && productsForTabs.some((p) => p?.category === "FDF");
  const hasDiagnosticsProducts = hasProductData && productsForTabs.some((p) => p?.category === "Diagnostics");
  // When loaded with no product data (e.g. API error), show all tabs as fallback
  const showApiTabRaw = !partnerProductsLoaded || !hasProductData || hasApiProducts;
  const showFdfTabRaw = !partnerProductsLoaded || !hasProductData || hasFdfProducts;
  const showDiagnosticsTabRaw = !partnerProductsLoaded || !hasProductData || hasDiagnosticsProducts;
  const isDiagnosticAdmin = (getRole() === "DIAGNOSTIC_ADMIN" || getRole() === "DIAGNOSTIC_REVIEWER");
  const showApiTab = isDiagnosticAdmin ? false : showApiTabRaw;
  const showFdfTab = isDiagnosticAdmin ? false : showFdfTabRaw;
  const showDiagnosticsTab = isDiagnosticAdmin ? true : showDiagnosticsTabRaw;
  const { salesrequestdata } = useSelector(({ royaltySales }) => royaltySales);

  const { data: royaltySalesRequests = [], isLoading: isRoyaltyRequestsLoading } = useGetRoyaltySalesRequestQuery(
    { 
      isApproved: true, 
      partner_id: id && (getRole() === "ADMIN" || getRole() === "STAFF") ? id : null,
      ordering: "mapping_id",
    },
    {
      refetchOnMountOrArgChange: true, // Ensure it refetches when params change
    }
  );

  const getSalesRequestFilteredDropdownValues = (params) => {
    const { country_name, product_name } = params.data;

    const filteredValues = royaltySalesRequests
      .filter((item) => {
        return (
          item.sales_data.some(sale => 
            sale.country_id.country_name === country_name &&
            sale.product_id.product_name === product_name
          )
        );
      })
      .map((item) => ({
        request_id: item.request_id,
        mapping_id: item.mapping_id,
        quantity: item.sales_data[0].quantity,
        expected_date_of_sale: `${item.sales_data[0].month} ${item.sales_data[0].year}`,
        country_name: item.sales_data[0].country_id.country_name,
        product_name: item.sales_data[0].product_id.product_name,
        buyer_name_and_address: item.buyer_name_and_address || 'Not specified'
      }));

    return filteredValues;
  };

  const getFilteredDropdownValues = (params) => {
    const { country_name, product_name } = params.data;

    const filteredValues = salesrequestdata
      .filter((item) => {
        return (
          item.country_id.country_name === country_name &&
          item.product_id.product_name === product_name
        );
      })
      .map(
        ({
          request_id,
          quantity,
          country_id,
          product_id,
          expected_date_of_sale,
          mapping_id,
          buyer_name_and_address,
        }) => ({
          request_id,
          mapping_id,
          quantity,
          expected_date_of_sale,
          country_name: country_id.country_name,
          product_name: product_id.product_name,
          buyer_name_and_address,
        }),
      );

    return filteredValues;
  };

  const handleDataUpdate = (params) => {
    params.data.request_id__mapping_id = null;
    const colId = params.column.getColId();
    params.api.refreshCells({ rowNodes: [params.node], columns: [colId] });
  };

  useEffect(() => {
    setSalesReport();
  }, []);

  useEffect(() => {
    if (isDataReady && !isFdfInitialized) {
      addApiColumns();
    }
    if (isFdfInitialized) {
      addFdfColumns();
    }
    if (isDataReady) {
      addDiagnosticsColumns();
    }
  }, [isDataReady, isFdfInitialized, fdfRequestError]);

  // When products load, if current tab is hidden, switch to first visible tab (partner + admin)
  useEffect(() => {
    if (!partnerProductsLoaded) return;
    if (tabKey === "api" && !showApiTab) {
      if (showFdfTab) setTabKey("fdf");
      else if (showDiagnosticsTab) setTabKey("diagnostics");
    } else if (tabKey === "fdf" && !showFdfTab) {
      if (showApiTab) setTabKey("api");
      else if (showDiagnosticsTab) setTabKey("diagnostics");
    } else if (tabKey === "diagnostics" && !showDiagnosticsTab) {
      if (showApiTab) setTabKey("api");
      else if (showFdfTab) setTabKey("fdf");
    }
  }, [partnerProductsLoaded, tabKey, showApiTab, showFdfTab, showDiagnosticsTab]);

// Update column definitions when royaltySalesRequests data changes
  useEffect(() => {
    if (isDataReady && royaltySalesRequests?.results?.length > 0) {
      addApiColumns();
      addFdfColumns();
    }
  }, [royaltySalesRequests, isRoyaltyRequestsLoading]);

  const changeQuarter = (e) => {
    const quarterValue = e.target ? e.target.value : e;
    const apiQuarterFormat = quarterValue.replace(/\s+to\s+/, '-');

    // Convert current quarter display format to API format for comparison
    const currentQuarterApiFormat = quarterDropdownCurrent.replace(/\s+to\s+/, '-');

    // Compare both in API format
    if (apiQuarterFormat === currentQuarterApiFormat) {
      if (apiGridApi) {
        apiGridApi.isHistoricQuarter = false;
        apiGridApi.refreshCells();
      }
      if (isFdfInitialized && fdfGridApi) {
        fdfGridApi.isHistoricQuarter = false;
        fdfGridApi.refreshCells();
      }
      setIsHistoricQuarter(false);
      setSalesReport();
    } else {
      if (apiGridApi) {
        apiGridApi.isHistoricQuarter = true;
        apiGridApi.refreshCells();
      }
      if (isFdfInitialized && fdfGridApi) {
        fdfGridApi.isHistoricQuarter = true;
        fdfGridApi.refreshCells();
      }
      setIsHistoricQuarter(true);
      setSalesReport(apiQuarterFormat);
    }
  };

  const navigateBack = () => {
    if (isUserAdmin || isUserStaff) {
      navigate("/admin/partner-list");
    }
  };

  const setSalesReport = (quarter_name = null) => {
    setIsLoading(true);
    if (id) {
      setIsUserAdmin(() => {
        return getRole() === "ADMIN";
      });
      setIsUserStaff(() => {
        return getRole() === "STAFF";
      });
      dispatch(
        getAdminApiSalesData(
          id,
          (apiData) => {
            setApiValues(apiData);
            setQuarterDropdown(apiData.quarter_dropdown);
            setQuarterDropdownCurrent(apiData.sales_meta.quarter_name);
            dispatch(
              getAdminFdfSalesData(
                id,
                (fdfData) => {
                  setFdfValues(fdfData);
                  setPartnerId(id);
                  dispatch(
                    getAdminDiagnosticsSalesData(
                      id,
                      (diagnosticsData) => {
                        setDiagnosticsValues(diagnosticsData);
                        dispatch(
                          getSalesRequestData(true, id, () => {
                            setIsDataReady(true);
                            setIsLoading(false);
                          }),
                        );
                      },
                      quarter_name,
                    ),
                  );
                },
                quarter_name,
              ),
            );
          },
          quarter_name,
        ),
      );
    } else {
      dispatch(
        getApiSalesData((apiData) => {
          setApiValues(apiData);
          setQuarterDropdown(apiData.quarter_dropdown);
          setQuarterDropdownCurrent(apiData.sales_meta.quarter_name);
          dispatch(
            getFdfSalesData((fdfData) => {
              setFdfValues(fdfData);
              dispatch(
                getDiagnosticsSalesData((diagnosticsData) => {
                  setDiagnosticsValues(diagnosticsData);
                  dispatch(
                    getSalesRequestData(true, id, () => {
                      setIsDataReady(true);
                      setIsLoading(false);
                    }),
                  );
                }, quarter_name),
              );
            }, quarter_name),
          );
        }, quarter_name),
      );
    }
  };

  const setApiValues = (data) => {
    const {
      country_order,
      product_order,
      rows,
      sales_meta,
      unread_message_count,
      pending_product_count,
      quarter_dropdown
    } = data;
    
    setCountryOrder(country_order && country_order.length ? country_order : []);
    setCountryDropdown(
      country_order && country_order.length
        ? country_order.map((value) => value.country_name)
        : [],
    );
    setApiProductOrder(
      product_order && product_order.length ? product_order : [],
    );
    setApiProductDropdown(
      product_order && product_order.length
        ? product_order.map((value) => value.product_name)
        : [],
    );
    setYearDropdown(yearList());
    setMonthDropdown(monthArray.map((value) => value.name));
    setApiRowData(initRowData(rows));
    setReportDetails(sales_meta);
    setMessageCount(unread_message_count);
    setPendingProducts(pending_product_count);
    
    // Transform quarter dropdown display format
    const transformedQuarterDropdown = quarter_dropdown.map(quarter => 
      quarter.replace(/-/g, ' to ') // Convert "Jan-Mar 2025" to "Jan to Mar 2025"
    );
    setQuarterDropdown(transformedQuarterDropdown);
    
    setQuarterDropdownCurrent(sales_meta.quarter_name.replace(/-/g, ' to '));
  };

  const setFdfValues = (data) => {
    const { product_order, rows, sales_meta, unread_message_count } = data;
    setFdfProductOrder(
      product_order && product_order.length ? product_order : [],
    );
    setFdfProductDropdown(
      product_order && product_order.length
        ? product_order.map((value) => value.product_name)
        : [],
    );
    setFdfRowData(initRowData(rows));
    setReportDetails(sales_meta);
    setMessageCount(unread_message_count);
    
    // No need to set quarter dropdown here again since it's already set in setApiValues
    // Just ensure the current quarter display uses the "to" format
    if (sales_meta && sales_meta.quarter_name) {
      setQuarterDropdownCurrent(sales_meta.quarter_name.replace(/-/g, ' to '));
    }
  };

  const setDiagnosticsValues = (data) => {
    const { product_order, rows, sales_meta, unread_message_count } = data;
    setDiagnosticsProductOrder(
      product_order && product_order.length ? product_order : [],
    );
    setDiagnosticsProductDropdown(
      product_order && product_order.length
        ? product_order.map((value) => value.product_name)
        : [],
    );
    setDiagnosticsRowData(initRowData(rows));
    setReportDetails(sales_meta);
    setMessageCount(unread_message_count);
    
    // Ensure the current quarter display uses the "to" format
    if (sales_meta && sales_meta.quarter_name) {
      setQuarterDropdownCurrent(sales_meta.quarter_name.replace(/-/g, ' to '));
    }
  };

  const onApiGridReady = (params) => {
    params.api["isHistoricQuarter"] = isHistoricQuarter;
    setApiGridApi(params.api);
  };

  const onFdfGridReady = (params) => {
    params.api["isHistoricQuarter"] = isHistoricQuarter;
    setFdfGridApi(params.api);
    setIsFdfInitialized(true);
  };

  const onDiagnosticsGridReady = (params) => {
    params.api["isHistoricQuarter"] = isHistoricQuarter;
    setDiagnosticsGridApi(params.api);
    // Set column definitions when grid is ready
    if (DiagnosticsColumnDefs && DiagnosticsColumnDefs.length > 0) {
      params.api.setColumnDefs(DiagnosticsColumnDefs);
    }
  };

  // Fix grid visibility when Diagnostics tab becomes active; auto-size columns to fit content
  useEffect(() => {
    if (tabKey === "diagnostics" && diagnosticsGridApi) {
      setTimeout(() => {
        diagnosticsGridApi.autoSizeAllColumns();
      }, 0);
    }
  }, [tabKey, diagnosticsGridApi]);

  const refreshGrid = () => {
    if (fdfGridApi) {
      fdfGridApi.refreshCells();
    }
  };

  if (fdfRequestError.mapping_id && fdfGridApi) {
    fdfGridApi.refreshCells();
  }


  const addApiColumns = () => {
    let apiColumns = [
      {
        headerName: "Sr.No",
        checkboxSelection: true,
        valueGetter: "node.rowIndex + 1",
        headerCheckboxSelection: true,
        width: 100,
      },
      {
        headerName: "Year",
        field: "year",
        cellEditorSelector: (params) => {
          return {
            component: "agRichSelect",
            params: { values: yearDropdown },
          };
        },
        cellClassRules: {
          "error-cell": (params) => {
            const { value } = params;
            return (
              (isNaN(value) ||
                (!isNaN(value) && !yearDropdown.includes(value))) &&
              value
            );
          },
        },
        width: 120,
      },
      {
        headerName: "Month",
        field: "month",
        cellEditorSelector: (params) => {
          return {
            component: "agRichSelect",
            params: { values: monthDropdown },
          };
        },
        cellClassRules: {
          "error-cell": (params) => {
            const { value } = params;
            return !monthDropdown.includes(value) && value;
          },
        },
        width: 150,
      },
      {
        headerName: "Quarter",
        colId: "year&month",
        editable: false,
        valueGetter: (params) => {
          const { data } = params;
          if (data.month && data.year) {
            const monthInt = moment().month(data.month).format("M");
            const quarter_num =
              monthInt % 3 !== 0
                ? parseInt(monthInt / 3) + 1
                : parseInt(monthInt / 3);
            return `Q${quarter_num} - ${data.year}`;
          } else {
            return null;
          }
        },
        cellClassRules: {
          "non-editable-cell": (params) => {
            return true;
          },
        },
        width: 100,
      },
      {
        headerName: "Country",
        field: "country_name",
        cellEditor: "countrySelector",
        cellEditorPopup: true,
        selectValues: countryDropdown,
        cellClassRules: {
          "error-cell": (params) => {
            const { value } = params;
            return !countryDropdown.includes(value) && value;
          },
        },
        width: 200,
      },
      {
        headerName: "Purchaser",
        field: "purchaser",
        width: 200,
      },
      {
        headerName: "Api Name",
        field: "product_name",
        cellEditor: "searchSelector",
        cellEditorPopup: true,
        selectValues: apiProductDropdown,
        suppressKeyboardEvent: (params) => {
          return suppressEnter(params);
        },
        width: 200,
        editable: (params) => {
          if (isUserAdmin && params.api.isHistoricQuarter !== true) {
            return true;
          } else if (
            !isUserStaff &&
            apiSalesList.sales_meta.report_status !== "Approved" &&
            params.api.isHistoricQuarter !== true
          ) {
            return true;
          } else {
            return false;
          }
        },
        cellClassRules: {
          "non-editable-cell": (params) => {
            const { isHistoricQuarter } = params.api;
            if (
              !isUserAdmin &&
              apiSalesList.sales_meta.report_status === "Approved"
            ) {
              return true;
            } else if (!isUserAdmin && isHistoricQuarter) {
              return true;
            } else if (isUserAdmin && params.api.isHistoricQuarter === true) {
              return true;
            } else if (isUserStaff) {
              return true;
            } else {
              return false;
            }
          },
        },
      },
      {
        headerName: "Quantity (Kg)",
        field: "quantity",
        type: "valueColumn",
        valueParser: (params) => {
          const { newValue } = params;
          return isNaN(newValue) ? newValue : Number(newValue);
        },
        cellClassRules: {
          "error-cell": (params) => {
            const { value } = params;
            return isNaN(value) && value !== null && value !== undefined;
          },
        },
        width: 200,
      },
      {
        headerName: "Total Value (USD)",
        field: "total_value",
        type: "valueColumn",
        valueParser: (params) => {
          const { newValue } = params;
          return isNaN(newValue) ? newValue : Number(newValue);
        },
        cellClassRules: {
          "error-cell": (params) => {
            const { value } = params;
            return isNaN(value) && value !== null && value !== undefined;
          },
        },
        width: 200,
      },
      {
        headerName: "Comments",
        field: "comments",
        width: 200,
      },
    ];
    setApiColumnDefs(apiColumns);
    if (apiProductDropdown && apiProductDropdown.length && apiGridApi) {
      apiGridApi.setColumnDefs(apiColumns);
    }
  };

  const addFdfColumns = () => {
    let fdfColumns = [
      {
        headerName: "Sr.No",
        checkboxSelection: true,
        valueGetter: "node.rowIndex + 1",
        headerCheckboxSelection: true,
        width: 100,
      },
      {
        headerName: "Year",
        field: "year",
        cellEditorSelector: (params) => {
          return {
            component: "agRichSelect",
            params: { values: yearDropdown },
          };
        },
        cellClassRules: {
          "error-cell": (params) => {
            const { value } = params;
            return (
              (isNaN(value) ||
                (!isNaN(value) && !yearDropdown.includes(value))) &&
              value
            );
          },
        },
        width: 100,
      },
      {
        headerName: "Month",
        field: "month",
        cellEditorSelector: (params) => {
          return {
            component: "agRichSelect",
            params: { values: monthDropdown },
          };
        },
        cellClassRules: {
          "error-cell": (params) => {
            const { value } = params;
            return !monthDropdown.includes(value) && value;
          },
        },
        width: 100,
      },
      {
        headerName: "Quarter",
        colId: "year&month",
        editable: false,
        valueGetter: (params) => {
          const { data } = params;
          if (data.month && data.year) {
            const monthInt = moment().month(data.month).format("M");
            const quarter_num =
              monthInt % 3 !== 0
                ? parseInt(monthInt / 3) + 1
                : parseInt(monthInt / 3);
            return `Q${quarter_num} - ${data.year}`;
          } else {
            return null;
          }
        },
        cellClassRules: {
          "non-editable-cell": (params) => {
            return true;
          },
        },
        width: 100,
      },
      {
        headerName: "Country",
        field: "country_name",
        cellEditor: "countrySelector",
        cellEditorPopup: true,
        selectValues: countryDropdown,
        cellClassRules: {
          "error-cell": (params) => {
            const { value } = params;
            return !countryDropdown.includes(value) && value;
          },
        },
        width: 200,
        onCellValueChanged: (params) => {
          handleDataUpdate(params);
        },
      },
      {
        headerName: "Purchaser",
        field: "purchaser",
        width: 200,
      },
      {
        headerName: "Product",
        field: "product_name",
        cellEditor: "productSelector",
        cellEditorPopup: true,
        selectValues: fdfProductDropdown,
        width: 200,
        editable: (params) => {
          if (isUserAdmin && params.api.isHistoricQuarter !== true) {
            return true;
          } else if (
            !isUserStaff &&
            apiSalesList.sales_meta.report_status !== "Approved" &&
            params.api.isHistoricQuarter !== true
          ) {
            return true;
          } else {
            return false;
          }
        },
        onCellValueChanged: (params) => {
          handleDataUpdate(params);
        },
        cellClassRules: {
          "non-editable-cell": (params) => {
            const { isHistoricQuarter } = params.api;
            if (
              !isUserAdmin &&
              apiSalesList.sales_meta.report_status === "Approved"
            ) {
              return true;
            } else if (!isUserAdmin && isHistoricQuarter) {
              return true;
            } else if (isUserAdmin && params.api.isHistoricQuarter === true) {
              return true;
            } else if (isUserStaff) {
              return true;
            } else {
              return false;
            }
          },
          "error-cell": (params) => {
            const { value } = params;
            return !fdfProductDropdown.includes(value) && value;
          },
        },
      },
      {
        headerName: "Strength",
        field: "strength",
        width: 150,
      },
      {
        headerName: "Formulation Type",
        field: "formulation_md",
        cellEditorSelector: (params) => {
          return {
            component: "agRichSelect",
            params: { values: formulationType },
          };
        },
        cellClassRules: {
          "error-cell": (params) => {
            const { value } = params;
            return !formulationType.includes(value) && value;
          },
        },
        width: 150,
      },
      {
        headerName: "Pack Size",
        field: "pack_size",
        type: "valueColumn",
        valueParser: (params) => {
          const { newValue } = params;
          return isNaN(newValue) ? newValue : Number(newValue);
        },
        cellClassRules: {
          "error-cell": (params) => {
            const { value } = params;
            return isNaN(value) && value;
          },
        },
        width: 100,
      },
      {
        headerName: "Quantity",
        field: "quantity",
        type: "valueColumn",
        valueParser: (params) => {
          const { newValue } = params;
          return isNaN(newValue) ? newValue : Number(newValue);
        },
        cellClassRules: {
          "error-cell": (params) => {
            const { value } = params;
            return isNaN(value) && value;
          },
        },
        width: 100,
      },
      ...(isUserDetails?.is_royalty_partner || reportDetails?.is_royalty_partner
        ? [
            {
              headerName: "Request ID",
              colId: "request_id__mapping_id",
              field: "request_id__mapping_id",
              cellRenderer: (params) => (
                <PopupCellRenderer 
                  params={params}
                  royaltySalesRequests={royaltySalesRequests?.results || []}
                  isLoading={isRoyaltyRequestsLoading} // Make sure this is passed correctly
                />
              ),
              cellClassRules: {
                "error-cell": (params) => {
                  const { value, data } = params;
                  let requestIdError = false;
                  if (fdfRequestError?.mapping_id) {
                    requestIdError = value === fdfRequestError?.mapping_id ? true : false;
                  }
                  if (
                    reportDetails?.partner_name === "Emcure" &&
                    data.country_name === "India"
                  ) {
                    requestIdError = false;
                  } else {
                    for (let country of royalty_countries_product) {
                      if (country.country_id === data.country_id) {
                        for (let countryProduct of country.product) {
                          if (
                            countryProduct.product_name === data.product_name &&
                            !value
                          ) {
                            requestIdError = true;
                          }
                        }
                      }
                    }
                  }
                  return requestIdError;
                },
              },
              editable: false,
              maxWidth: 150,
            },
          ]
        : []),

      {
        headerName: "Currency",
        field: "currency",
        cellEditorSelector: (params) => {
          return {
            component: "agRichSelect",
            params: { values: Object.keys(currencyList) },
          };
        },
        cellClassRules: {
          "error-cell": (params) => {
            const { value } = params;
            let currenyArr = Object.keys(currencyList);
            return !currenyArr.includes(value) && value;
          },
        },
        width: 100,
      },
      {
        headerName: "Gross Sale Price (per pack) (Local Currency)",
        field: "gross_sale_price_currency",
        type: "valueColumn",
        valueParser: (params) => {
          const { newValue } = params;
          return isNaN(newValue) ? newValue : Number(newValue);
        },
        cellClassRules: {
          "error-cell": (params) => {
            const { value } = params;
            return isNaN(value) && value;
          },
        },
        width: 300,
      },
      {
        headerName: "Applicable Currency Exchange Rate to USD",
        field: "usd_exchange_rate",
        type: "valueColumn",
        valueParser: (params) => {
          const { newValue } = params;
          return isNaN(newValue) ? newValue : Number(newValue);
        },
        cellClassRules: {
          "error-cell": (params) => {
            const { value } = params;
            return isNaN(value) && value;
          },
        },
        width: 300,
      },
      {
        headerName: "Gross Sale Price (per pack) (USD)",
        field: "gross_sale_price_usd",
        type: "valueColumn",
        valueParser: (params) => {
          const { newValue } = params;
          return isNaN(newValue) ? newValue : Number(newValue);
        },
        cellClassRules: {
          "error-cell": (params) => {
            const { value } = params;
            return isNaN(value) && value;
          },
        },
        width: 300,
      },
      {
        headerName: "Total Gross Sales Value (USD)",
        field: "total_gross_value",
        type: "valueColumn",
        valueParser: (params) => {
          const { newValue } = params;
          return isNaN(newValue) ? newValue : Number(newValue);
        },
        cellClassRules: {
          "error-cell": (params) => {
            const { value } = params;
            return isNaN(value) && value;
          },
        },
        width: 300,
      },
      {
        headerName: "Deductable Expenses (USD)",
        field: "deductable_expenses",
        type: "valueColumn",
        valueParser: (params) => {
          const { newValue } = params;
          return isNaN(newValue) ? newValue : Number(newValue);
        },
        cellClassRules: {
          "error-cell": (params) => {
            const { value } = params;
            return isNaN(value) && value;
          },
        },
        width: 200,
      },
      {
        headerName: "Total Net Sales Value",
        field: "total_value",
        type: "valueColumn",
        valueParser: (params) => {
          const { newValue } = params;
          return isNaN(newValue) ? newValue : Number(newValue);
        },
        cellClassRules: {
          "error-cell": (params) => {
            const { value } = params;
            return isNaN(value) && value;
          },
        },
        width: 200,
      },
      {
        headerName: "Royalty %",
        field: "royalty_percent",
        type: "valueColumn",
        valueParser: (params) => {
          const { newValue } = params;
          return isNaN(newValue) ? newValue : Number(newValue);
        },
        cellClassRules: {
          "error-cell": (params) => {
            const { value } = params;
            return isNaN(value) && value;
          },
        },
        width: 100,
      },
      {
        headerName: "Royalty Due",
        field: "royalty_due",
        type: "valueColumn",
        valueParser: (params) => {
          const { newValue } = params;
          return isNaN(newValue) ? newValue : Number(newValue);
        },
        cellClassRules: {
          "error-cell": (params) => {
            const { value } = params;
            return isNaN(value) && value;
          },
        },
        width: 200,
      },
      {
        headerName: "Procurement Agency End-Country",
        field: "procurement_end_country",
        width: 150,
      },
      {
        headerName: "Comments",
        field: "comments",
        width: 200,
      },
    ];
    setFdfColumnDefs(fdfColumns);
    if (fdfProductDropdown && fdfProductDropdown.length && fdfGridApi) {
      fdfGridApi.setColumnDefs(fdfColumns);
    }
  };

  const addDiagnosticsColumns = () => {
    let diagnosticsColumns = [
      {
        headerName: "Sr.No",
        checkboxSelection: true,
        valueGetter: "node.rowIndex + 1",
        headerCheckboxSelection: true,
        width: 100,
      },
      {
        headerName: "Year",
        field: "year",
        cellEditorSelector: (params) => {
          return {
            component: "agRichSelect",
            params: { values: yearDropdown },
          };
        },
        cellClassRules: {
          "error-cell": (params) => {
            const { value } = params;
            return (
              (isNaN(value) ||
                (!isNaN(value) && !yearDropdown.includes(value))) &&
              value
            );
          },
        },
        width: 100,
      },
      {
        headerName: "Month",
        field: "month",
        cellEditorSelector: (params) => {
          return {
            component: "agRichSelect",
            params: { values: monthDropdown },
          };
        },
        cellClassRules: {
          "error-cell": (params) => {
            const { value } = params;
            return !monthDropdown.includes(value) && value;
          },
        },
        width: 100,
      },
      {
        headerName: "Quarter",
        colId: "year&month",
        editable: false,
        valueGetter: (params) => {
          const { data } = params;
          if (data.month && data.year) {
            const monthInt = moment().month(data.month).format("M");
            const quarter_num =
              monthInt % 3 !== 0
                ? parseInt(monthInt / 3) + 1
                : parseInt(monthInt / 3);
            return `Q${quarter_num} - ${data.year}`;
          } else {
            return null;
          }
        },
        cellClassRules: {
          "non-editable-cell": (params) => {
            return true;
          },
        },
        width: 100,
      },
      {
        headerName: "Country",
        field: "country_name",
        cellEditor: "countrySelector",
        cellEditorPopup: true,
        selectValues: countryDropdown,
        cellClassRules: {
          "error-cell": (params) => {
            const { value } = params;
            return !countryDropdown.includes(value) && value;
          },
        },
        width: 200,
      },
      {
        headerName: "Purchaser",
        field: "purchaser",
        width: 200,
      },
      {
        headerName: "Product",
        field: "product_name",
        cellEditor: "searchSelector",
        cellEditorPopup: true,
        selectValues: diagnosticsProductDropdown,
        suppressKeyboardEvent: (params) => {
          return suppressEnter(params);
        },
        width: 200,
        editable: (params) => {
          if (isUserAdmin && params.api.isHistoricQuarter !== true) {
            return true;
          } else if (
            !isUserStaff &&
            apiSalesList.sales_meta.report_status !== "Approved" &&
            params.api.isHistoricQuarter !== true
          ) {
            return true;
          } else {
            return false;
          }
        },
        cellClassRules: {
          "non-editable-cell": (params) => {
            const { isHistoricQuarter } = params.api;
            if (
              !isUserAdmin &&
              apiSalesList.sales_meta.report_status === "Approved"
            ) {
              return true;
            } else if (!isUserAdmin && isHistoricQuarter) {
              return true;
            } else if (isUserAdmin && params.api.isHistoricQuarter === true) {
              return true;
            } else if (isUserStaff) {
              return true;
            } else {
              return false;
            }
          },
          // Removed error-cell for product_name: valid products from saved data can differ in format
          // from product_order; red styling was causing false positives.
        },
      },
      {
        headerName: "Pack Size",
        field: "pack_size",
        type: "valueColumn",
        valueParser: (params) => {
          const { newValue } = params;
          return isNaN(newValue) ? newValue : Number(newValue);
        },
        cellClassRules: {
          "error-cell": (params) => {
            const { value } = params;
            return isNaN(value) && value;
          },
        },
        width: 100,
      },
      {
        headerName: "Quantity",
        field: "quantity",
        type: "valueColumn",
        valueParser: (params) => {
          const { newValue } = params;
          return isNaN(newValue) ? newValue : Number(newValue);
        },
        cellClassRules: {
          "error-cell": (params) => {
            const { value } = params;
            return isNaN(value) && value;
          },
        },
        width: 100,
      },
      {
        headerName: "Currency",
        field: "currency",
        cellEditorSelector: (params) => {
          return {
            component: "agRichSelect",
            params: { values: Object.keys(currencyList) },
          };
        },
        cellClassRules: {
          "error-cell": (params) => {
            const { value } = params;
            let currenyArr = Object.keys(currencyList);
            return !currenyArr.includes(value) && value;
          },
        },
        width: 100,
      },
      {
        headerName: "Gross Sale Price (Local Currency)",
        field: "gross_sale_price_currency",
        type: "valueColumn",
        valueParser: (params) => {
          const { newValue } = params;
          return isNaN(newValue) ? newValue : Number(newValue);
        },
        cellClassRules: {
          "error-cell": (params) => {
            const { value } = params;
            return isNaN(value) && value;
          },
        },
        width: 250,
      },
      {
        headerName: "Exchange Rate",
        field: "usd_exchange_rate",
        type: "valueColumn",
        valueParser: (params) => {
          const { newValue } = params;
          return isNaN(newValue) ? newValue : Number(newValue);
        },
        cellClassRules: {
          "error-cell": (params) => {
            const { value } = params;
            return isNaN(value) && value;
          },
        },
        width: 150,
      },
      {
        headerName: "Gross Sale Price (USD)",
        field: "gross_sale_price_usd",
        type: "valueColumn",
        valueParser: (params) => {
          const { newValue } = params;
          return isNaN(newValue) ? newValue : Number(newValue);
        },
        cellClassRules: {
          "error-cell": (params) => {
            const { value } = params;
            return isNaN(value) && value;
          },
        },
        width: 200,
      },
      {
        headerName: "Deductible Expenses",
        field: "deductable_expenses",
        type: "valueColumn",
        valueParser: (params) => {
          const { newValue } = params;
          return isNaN(newValue) ? newValue : Number(newValue);
        },
        cellClassRules: {
          "error-cell": (params) => {
            const { value } = params;
            return isNaN(value) && value;
          },
        },
        width: 180,
      },
      {
        headerName: "Total Net Sales Value",
        field: "total_value",
        type: "valueColumn",
        valueParser: (params) => {
          const { newValue } = params;
          return isNaN(newValue) ? newValue : Number(newValue);
        },
        cellClassRules: {
          "error-cell": (params) => {
            const { value } = params;
            return isNaN(value) && value;
          },
        },
        width: 200,
      },
      {
        headerName: "Royalty %",
        field: "royalty_percent",
        type: "valueColumn",
        valueParser: (params) => {
          const { newValue } = params;
          return isNaN(newValue) ? newValue : Number(newValue);
        },
        cellClassRules: {
          "error-cell": (params) => {
            const { value } = params;
            return isNaN(value) && value;
          },
        },
        width: 100,
      },
      {
        headerName: "Royalty Due",
        field: "royalty_due",
        type: "valueColumn",
        valueParser: (params) => {
          const { newValue } = params;
          return isNaN(newValue) ? newValue : Number(newValue);
        },
        cellClassRules: {
          "error-cell": (params) => {
            const { value } = params;
            return isNaN(value) && value;
          },
        },
        width: 150,
      },
      {
        headerName: "Procurement Agency End Country",
        field: "procurement_end_country",
        width: 200,
      },
      {
        headerName: "Comments",
        field: "comments",
        width: 200,
      },
    ];
    setDiagnosticsColumnDefs(diagnosticsColumns);
    if (diagnosticsProductDropdown && diagnosticsProductDropdown.length && diagnosticsGridApi) {
      diagnosticsGridApi.setColumnDefs(diagnosticsColumns);
    }
  };

  const addApiRow = () => {
    let rowData = [...ApiRowData];
    for (let i = 0; i < addApiRowNumber; i++) {
      rowData.push({});
    }
    setApiRowData(rowData);
    setAddApiRowNumber(0);
  };

  const addFdfRow = () => {
    let rowData = [...FdfRowData];
    for (let i = 0; i < addFdfRowNumber; i++) {
      rowData.push({});
    }
    setFdfRowData(rowData);
    setAddFdfRowNumber(0);
  };

  const addDiagnosticsRow = () => {
    let rowData = [...DiagnosticsRowData];
    for (let i = 0; i < addDiagnosticsRowNumber; i++) {
      rowData.push({});
    }
    setDiagnosticsRowData(rowData);
    setAddDiagnosticsRowNumber(0);
  };

  const checkApiRowNodes = (dataList) => {
    if (dataList.some((value) => checkApiRow(value).flag)) {
      let errorData = dataList.filter((val) => checkApiRow(val).flag);
      let errorIndex = dataList
        .map((val, index) => {
          if (checkApiRow(val).flag === true) {
            return index + 1;
          }
        })
        .filter((val) => val !== undefined);
      let apiErrorList = errorData.map((val, index) => ({
        errorkeys: checkApiRow(val).errorKey,
        index: errorIndex[index],
      }));
      let errMsg = () => {
        return (
          <div>
            <p className="mt-20 mb-10">Please Check API Table</p>
            {apiErrorList.map((value, rowNo) => {
              return (
                <div>
                  <h4 className="mr-5 mt-10">Row No. {value.index}: </h4>
                  <p>
                    {value.errorkeys.map((val, index) =>
                      value.errorkeys.length === index + 1 ? val : val + ", ",
                    )}
                  </p>
                  {apiErrorList.length === rowNo + 1 ? null : <Divider />}
                </div>
              );
            })}
          </div>
        );
      };

      Modal.error({
        title: "Invalid data!",
        content: errMsg(),
      });
    }
    return !dataList.some((value) => checkApiRow(value).flag);
  };

  const checkApiRow = (rowData) => {
    let flag = false;
    let errorKey = [];
    for (let key in rowData) {
      if (Object.prototype.hasOwnProperty.call(rowData, key)) {
        if (
          key === "year" &&
          (isNaN(rowData["year"]) ||
            !yearDropdown.includes(Number(rowData["year"]))) &&
          rowData["year"] !== "" &&
          rowData["year"] !== null
        ) {
          flag = true;
          errorKey.push("Year");
        }
        if (
          key === "month" &&
          !monthDropdown.includes(rowData["month"]) &&
          rowData["month"] !== "" &&
          rowData["month"] !== null
        ) {
          flag = true;
          errorKey.push("Month");
        }
        if (
          key === "country_name" &&
          !countryDropdown.includes(rowData["country_name"]) &&
          rowData["country_name"] !== "" &&
          rowData["country_name"] !== null
        ) {
          flag = true;
          errorKey.push("Country");
        }
        if (
          key === "quantity" &&
          isNaN(rowData["quantity"]) &&
          rowData["quantity"] !== null
        ) {
          flag = true;
          errorKey.push("Quantity");
        }
        if (
          key === "total_value" &&
          isNaN(rowData["total_value"]) &&
          rowData["total_value"] !== null
        ) {
          flag = true;
          errorKey.push("Total Value");
        }
      }
    }
    return { flag, errorKey };
  };

  const checkFdfRowNodes = (dataList) => {
    if (dataList.some((value) => checkFdfRow(value).flag)) {
      let errorData = dataList.filter((val) => checkFdfRow(val).flag);
      let errorIndex = dataList
        .map((val, index) => {
          if (checkFdfRow(val).flag === true) {
            return index + 1;
          }
        })
        .filter((val) => val !== undefined);
      let fdfErrorList = errorData.map((val, index) => ({
        errorkeys: checkFdfRow(val).errorKey,
        index: errorIndex[index],
      }));
      let errMsg = () => {
        return (
          <div>
            <p>Please Check FDF Table:</p>
            {fdfErrorList.map((value, rowNo) => {
              return (
                <div>
                  <h4 className="mr-5 mt-10">Row No. {value.index}: </h4>
                  <p>
                    {value.errorkeys.map((val, index) =>
                      value.errorkeys.length === index + 1 ? val : val + ", ",
                    )}
                  </p>
                  {fdfErrorList.length === rowNo + 1 ? null : <Divider />}
                </div>
              );
            })}
          </div>
        );
      };

      Modal.error({
        title: "Invalid data!",
        content: errMsg(),
      });
    }
    return !dataList.some((value) => checkFdfRow(value).flag);
  };

  const checkFdfRow = (rowData) => {
    let flag = false;
    let errorKey = [];
    for (let key in rowData) {
      if (Object.prototype.hasOwnProperty.call(rowData, key)) {
        if (
          key === "year" &&
          (isNaN(rowData["year"]) ||
            !yearDropdown.includes(Number(rowData["year"]))) &&
          rowData["year"] !== "" &&
          rowData["year"] !== null
        ) {
          flag = true;
          errorKey.push("Year");
        }
        if (
          key === "month" &&
          !monthDropdown.includes(rowData["month"]) &&
          rowData["month"] !== "" &&
          rowData["month"] !== null
        ) {
          flag = true;
          errorKey.push("Month");
        }
        if (
          key === "country_name" &&
          !countryDropdown.includes(rowData["country_name"]) &&
          rowData["country_name"] !== "" &&
          rowData["country_name"] !== null
        ) {
          flag = true;
          errorKey.push("Country");
        }
        if (
          key === "quantity" &&
          isNaN(rowData["quantity"]) &&
          rowData["quantity"] !== null
        ) {
          flag = true;
          errorKey.push("Quantity");
        }
        if (
          key === "formulation_md" &&
          !formulationType.includes(rowData["formulation_md"]) &&
          rowData["formulation_md"] !== "" &&
          rowData["formulation_md"] !== null
        ) {
          flag = true;
          errorKey.push("Formulation Type");
        }
        if (
          key === "pack_size" &&
          isNaN(rowData["pack_size"]) &&
          rowData["pack_size"] !== null
        ) {
          flag = true;
          errorKey.push("Pack Size");
        }
        if (
          key === "currency" &&
          !Object.keys(currencyList).includes(rowData["currency"]) &&
          rowData["currency"] &&
          rowData["currency"] !== null
        ) {
          flag = true;
          errorKey.push("Currency");
        }
        if (
          key === "gross_sale_price_currency" &&
          isNaN(rowData["gross_sale_price_currency"]) &&
          rowData["gross_sale_price_currency"] !== null
        ) {
          flag = true;
          errorKey.push("Gross Sale Price (per pack) (Local Currency)");
        }
        if (
          key === "usd_exchange_rate" &&
          isNaN(rowData["usd_exchange_rate"]) &&
          rowData["usd_exchange_rate"] !== null
        ) {
          flag = true;
          errorKey.push("Applicable Currency Exchange Rate");
        }
        if (
          key === "gross_sale_price_usd" &&
          isNaN(rowData["gross_sale_price_usd"]) &&
          rowData["gross_sale_price_usd"] !== null
        ) {
          flag = true;
          errorKey.push("Gross Sale Price (per pack) (USD)");
        }
        if (
          key === "total_gross_value" &&
          isNaN(rowData["total_gross_value"]) &&
          rowData["total_gross_value"] !== null
        ) {
          flag = true;
          errorKey.push("Total Gross Sales Value (USD)");
        }
        if (
          key === "deductable_expenses" &&
          isNaN(rowData["deductable_expenses"]) &&
          rowData["deductable_expenses"] !== null
        ) {
          flag = true;
          errorKey.push("Deductable Expenses (USD)");
        }
        if (
          key === "total_value" &&
          isNaN(rowData["total_value"]) &&
          rowData["total_value"] !== null
        ) {
          flag = true;
          errorKey.push("Total Net Sales Value");
        }
        if (key === "royalty_percent" && isNaN(rowData["royalty_percent"])) {
          flag = true;
          errorKey.push("Royalty %");
        }
        if (key === "royalty_due" && isNaN(rowData["royalty_due"])) {
          flag = true;
          errorKey.push("Royalty Due");
        }
        if (
          key === "product_name" &&
          !fdfProductDropdown.includes(rowData["product_name"]) &&
          rowData["product_name"] !== "" &&
          rowData["product_name"] !== null
        ) {
          flag = true;
          errorKey.push("Product");
        }
      }
    }
    return { flag, errorKey };
  };

  const checkDiagnosticsRow = (rowData) => {
    // Diagnostics shares the FDF columns, but its products come from a different list
    const errorKey = checkFdfRow(rowData).errorKey.filter(
      (val) => val !== "Product",
    );
    if (
      has(rowData, "product_name") &&
      !diagnosticsProductDropdown.includes(rowData["product_name"]) &&
      rowData["product_name"] !== "" &&
      rowData["product_name"] !== null
    ) {
      errorKey.push("Product");
    }
    return { flag: errorKey.length > 0, errorKey };
  };

  const checkNullRow = (rowData) => {
    let flag = true;
    for (var key in rowData) {
      if (Object.prototype.hasOwnProperty.call(rowData, key)) {
        if (
          !(
            rowData[key] === null ||
            rowData[key] === undefined ||
            rowData[key] === 0 ||
            rowData[key] === ""
          )
        ) {
          flag = false;
          break;
        }
      }
    }
    return flag;
  };

  const validateDataForSubmission = () => {
  let errors = [];
  
  // Validate API data
  if (apiGridApi && !apiGridApi.isDestroyed()) {
    apiGridApi.stopEditing();
    let apiNodes = [];
    apiGridApi.forEachNode(node => apiNodes.push(node.data));
    apiNodes = apiNodes
      .filter(data => data && !isEmpty(data) && !checkNullRow(data));
    
    let apiValidationErrors = checkApiRowNodesForSubmission(apiNodes.map(node => node.data || node));
    if (apiValidationErrors.length > 0) {
      errors.push({
        section: 'API',
        errors: apiValidationErrors
      });
    }
  }
  
  // Validate FDF data
  if (fdfGridApi && !fdfGridApi.isDestroyed()) {
    fdfGridApi.stopEditing();
    let fdfNodes = [];
    fdfGridApi.forEachNode(node => fdfNodes.push(node.data));
    fdfNodes = fdfNodes
      .filter(data => data && !isEmpty(data) && !checkNullRow(data));
    
    let fdfValidationErrors = checkFdfRowNodesForSubmission(fdfNodes.map(node => node.data || node));
    if (fdfValidationErrors.length > 0) {
      errors.push({
        section: 'FDF', 
        errors: fdfValidationErrors
      });
    }
  }
  
  // Validate Diagnostics data
  const diagnosticsErrors = getInvalidRowsFromGrid(
    diagnosticsGridApi,
    checkDiagnosticsRow,
  );
  if (diagnosticsErrors.length > 0) {
    errors.push({
      section: 'Diagnostics',
      errors: diagnosticsErrors
    });
  }
  
  return errors;
};

const checkApiRowNodesForSubmission = (dataList) => {
  let allErrors = [];
  
  dataList.forEach((rowData, index) => {
    let rowErrors = checkApiRow(rowData);
    if (rowErrors.flag) {
      allErrors.push({
        rowNumber: index + 1,
        errors: rowErrors.errorKey
      });
    }
  });
  
  return allErrors;
};

const checkFdfRowNodesForSubmission = (dataList) => {
  let allErrors = [];
  
  dataList.forEach((rowData, index) => {
    let rowErrors = checkFdfRow(rowData);
    
    // Add Request-ID validation specifically for submission
    if (isUserDetails?.is_royalty_partner || reportDetails?.is_royalty_partner) {
      for (let country of royalty_countries_product) {
        if (country.country_id === rowData.country_id) {
          for (let countryProduct of country.product) {
            if (
              countryProduct.product_name === rowData.product_name &&
              !rowData.request_id__mapping_id
            ) {
              if (!(reportDetails?.partner_name === "Emcure" && rowData.country_name === "India")) {
                if (!rowErrors.flag) {
                  rowErrors.flag = true;
                  rowErrors.errorKey = [];
                }
                rowErrors.errorKey.push("Request ID");
              }
            }
          }
        }
      }
    }
    
    if (rowErrors.flag) {
      allErrors.push({
        rowNumber: index + 1,
        errors: rowErrors.errorKey
      });
    }
  });
  
  return allErrors;
};

const showValidationErrors = (validationErrors) => {
  let errorContent = (
    <div>
      <p className="mt-20 mb-10">Please fix the following errors before submitting:</p>
      {validationErrors.map((sectionError, sectionIndex) => (
        <div key={sectionIndex}>
          <h4 className="mr-5 mt-10">{sectionError.section} Section:</h4>
          {sectionError.errors.map((rowError, rowIndex) => (
            <div key={rowIndex}>
              <p><strong>Row {rowError.rowNumber}:</strong> {rowError.errors.join(', ')}</p>
              {rowIndex < sectionError.errors.length - 1 && <Divider />}
            </div>
          ))}
          {sectionIndex < validationErrors.length - 1 && <Divider />}
        </div>
      ))}
    </div>
  );

  Modal.error({
    title: "Validation Errors!",
    content: errorContent,
  });
};

  const saveApiData = (quarter_name = null, onDone = null) => {
    if (!apiGridApi) {
      console.warn('API Grid not initialized yet');
      return;
    }

    setIsActionLoading(true);
    
    const apiQuarterFormat = quarter_name ? quarter_name.replace(/\s+to\s+/, '-') : null;
    let apiData = [];
    apiGridApi.stopEditing();
    apiGridApi.selectAll();
    
    let selectedApiNodes = apiGridApi
      .getSelectedNodes()
      .filter((value) => value.data && !isEmpty(value.data))
      .filter((val) => !checkNullRow(val.data));
      
    // REMOVE the checkApiRowNodes validation here - allow saving even with validation errors
    // if (checkApiRowNodes(selectedApiNodes.map((value) => value.data))) {
    
    selectedApiNodes.forEach((value) => {
      let nodeData = { ...value.data };
      const { country_name, product_name } = nodeData;
      if (
        country_name &&
        countryOrder.map((value) => value.country_name).includes(country_name)
      ) {
        nodeData["country_id"] =
          countryOrder[
            findIndex(countryOrder, { country_name: country_name })
          ].country_id;
      }
      if (product_name && apiProductDropdown.includes(product_name)) {
        nodeData["product_id"] =
          apiProductOrder[
            findIndex(apiProductOrder, { product_name: product_name })
          ].product_id;
      }
      apiData.push(nodeData);
    });
    
    let finalApiData = apiData
      .filter((val) => !isEmpty(val))
      .filter((val) => !checkNullRow(val));
      
    if (isUserAdmin || isUserDiagnosticAdmin) {
      dispatch(
        postAdminApiSalesData(
          partnerId,
          [...deleteApiIds, ...finalApiData],
          () => {
            setIsActionLoading(false);
            var apiUpdatedRows = finalApiData.length - apiSalesList.rows.length;
            var apiSuccessMessage =
              `Data successfully recorded. Total Rows: ` +
              finalApiData.length +
              (apiUpdatedRows === 0
                ? ""
                : apiUpdatedRows < 0
                  ? ", Deleted Rows: " + Math.abs(apiUpdatedRows)
                  : `, Newly Added Rows: ` + apiUpdatedRows);
            showMessage("success", apiSuccessMessage);
            setDeleteApiIds([]);
            if (onDone) { onDone(); } else { setSalesReport(apiQuarterFormat); }
          },
          () => {
            setIsActionLoading(false);
          },
          apiQuarterFormat,
        ),
      );
    } else {
      dispatch(
        postApiSalesReportData([...deleteApiIds, ...finalApiData], 
          () => {
            setIsActionLoading(false);
            var apiUpdatedRows = finalApiData.length - apiSalesList.rows.length;
            var apiSuccessMessage =
              `Data successfully recorded. Total Rows: ` +
              finalApiData.length +
              (apiUpdatedRows === 0
                ? ""
                : apiUpdatedRows < 0
                  ? ", Deleted Rows: " + Math.abs(apiUpdatedRows)
                  : `, Newly Added Rows: ` + apiUpdatedRows);
            showMessage("success", apiSuccessMessage);
            setDeleteApiIds([]);
            if (onDone) { onDone(); } else { setSalesReport(); }
          },
          () => {
            setIsActionLoading(false);
          }
        ),
      );
    }
    apiGridApi.deselectAll();
    // } else {
    //   setIsActionLoading(false);
    //   apiGridApi.deselectAll();
    // }
  };

  const saveFdfData = (quarter_name = null, onDone = null) => {
    setIsActionLoading(true);
    
    const apiQuarterFormat = quarter_name ? quarter_name.replace(/\s+to\s+/, '-') : null;
    let fdfData = [];
    fdfGridApi.stopEditing();
    fdfGridApi.selectAll();
    
    try {
      let selectedFdfNodes = fdfGridApi
        .getSelectedNodes()
        .filter((value) => value.data && !isEmpty(value.data))
        .filter((val) => !checkNullRow(val.data));
        
      // REMOVE the checkFdfRowNodes validation here - allow saving even with validation errors
      // if (checkFdfRowNodes(selectedFdfNodes.map((value) => value.data))) {
      
      selectedFdfNodes.forEach((value) => {
        let nodeData = { ...value.data };
        const { country_name, product_name } = nodeData;
        
        // REMOVED: The Request-ID validation block that was here
        
        if (
          country_name &&
          countryOrder
            .map((value) => value.country_name)
            .includes(country_name)
        ) {
          nodeData["country_id"] =
            countryOrder[
              findIndex(countryOrder, { country_name: country_name })
            ].country_id;
        }
        if (product_name && fdfProductDropdown.includes(product_name)) {
          nodeData["product_id"] =
            fdfProductOrder[
              findIndex(fdfProductOrder, { product_name: product_name })
            ].product_id;
        }
        fdfData.push(nodeData);
      });
      
      let finalFdfData = fdfData
        .filter((val) => !isEmpty(val))
        .filter((value) => !checkNullRow(value));
        
      if (isUserAdmin || isUserDiagnosticAdmin) {
        dispatch(
          postAdminFdfSalesData(
            partnerId,
            [...deleteFdfIds, ...finalFdfData],
            () => {
              setIsActionLoading(false);
              var fdfUpdatedRows = finalFdfData.length - fdfSalesList.rows.length;
              var fdfSuccessMessage =
                `Data successfully recorded. Total Rows: ` +
                finalFdfData.length +
                (fdfUpdatedRows === 0
                  ? ""
                  : fdfUpdatedRows < 0
                    ? ", Deleted Rows: " + Math.abs(fdfUpdatedRows)
                    : `, Newly Added Rows: ` + fdfUpdatedRows);
              showMessage("success", fdfSuccessMessage);
              setDeleteFdfIds([]);
              if (onDone) { onDone(); } else { setSalesReport(apiQuarterFormat); }
            },
            () => {
              setIsActionLoading(false);
            },
            apiQuarterFormat,
          ),
        );
      } else {
        dispatch(
          postFdfSalesReportData([...deleteFdfIds, ...finalFdfData], 
            () => {
              setIsActionLoading(false);
              refreshGrid();
              var fdfUpdatedRows = finalFdfData.length - fdfSalesList.rows.length;
              var fdfSuccessMessage =
                `Data successfully recorded. Total Rows: ` +
                finalFdfData.length +
                (fdfUpdatedRows === 0
                  ? ""
                  : fdfUpdatedRows < 0
                    ? ", Deleted Rows: " + Math.abs(fdfUpdatedRows)
                    : `, Newly Added Rows: ` + fdfUpdatedRows);
              showMessage("success", fdfSuccessMessage);
              setDeleteFdfIds([]);
              if (onDone) { onDone(); } else { setSalesReport(); }
            },
            () => {
              setIsActionLoading(false);
              refreshGrid();
            }
          ),
        );
      }
      fdfGridApi.deselectAll();
    // } else {
    //   setIsActionLoading(false);
    //   fdfGridApi.deselectAll();
    // }
    } catch (err) {
      setIsActionLoading(false);
      console.log(err.toString());
      fdfGridApi.deselectAll();
      showMessage("error", err.toString());
    }
  };

  const saveDiagnosticsData = (quarter_name = null, onDone = null) => {
    if (!diagnosticsGridApi) {
      console.warn('Diagnostics Grid not initialized yet');
      return;
    }

    setIsActionLoading(true);
    
    const apiQuarterFormat = quarter_name ? quarter_name.replace(/\s+to\s+/, '-') : null;
    let diagnosticsData = [];
    diagnosticsGridApi.stopEditing();
    diagnosticsGridApi.selectAll();
    
    try {
      let selectedDiagnosticsNodes = diagnosticsGridApi
        .getSelectedNodes()
        .filter((value) => value.data && !isEmpty(value.data))
        .filter((val) => !checkNullRow(val.data));
      
      selectedDiagnosticsNodes.forEach((value) => {
        let nodeData = { ...value.data };
        const { country_name, product_name } = nodeData;
        if (
          country_name &&
          countryOrder.map((value) => value.country_name).includes(country_name)
        ) {
          nodeData["country_id"] =
            countryOrder[
              findIndex(countryOrder, { country_name: country_name })
            ].country_id;
        }
        if (product_name && diagnosticsProductDropdown.includes(product_name)) {
          nodeData["product_id"] =
            diagnosticsProductOrder[
              findIndex(diagnosticsProductOrder, { product_name: product_name })
            ].product_id;
        }
        diagnosticsData.push(nodeData);
      });
      
      let finalDiagnosticsData = diagnosticsData
        .filter((val) => !isEmpty(val))
        .filter((val) => !checkNullRow(val));
        
      if (isUserAdmin || isUserDiagnosticAdmin) {
        dispatch(
          postAdminDiagnosticsSalesData(
            partnerId,
            [...deleteDiagnosticsIds, ...finalDiagnosticsData],
            () => {
              setIsActionLoading(false);
              var diagnosticsUpdatedRows = finalDiagnosticsData.length - (diagnosticsSalesList?.rows?.length || 0);
              var diagnosticsSuccessMessage =
                `Data successfully recorded. Total Rows: ` +
                finalDiagnosticsData.length +
                (diagnosticsUpdatedRows === 0
                  ? ""
                  : diagnosticsUpdatedRows < 0
                    ? ", Deleted Rows: " + Math.abs(diagnosticsUpdatedRows)
                    : `, Newly Added Rows: ` + diagnosticsUpdatedRows);
              showMessage("success", diagnosticsSuccessMessage);
              setDeleteDiagnosticsIds([]);
              if (onDone) { onDone(); } else { setSalesReport(apiQuarterFormat); }
            },
            () => {
              setIsActionLoading(false);
            },
            apiQuarterFormat,
          ),
        );
      } else {
        dispatch(
          postDiagnosticsSalesReportData([...deleteDiagnosticsIds, ...finalDiagnosticsData], 
            () => {
              setIsActionLoading(false);
              var diagnosticsUpdatedRows = finalDiagnosticsData.length - (diagnosticsSalesList?.rows?.length || 0);
              var diagnosticsSuccessMessage =
                `Data successfully recorded. Total Rows: ` +
                finalDiagnosticsData.length +
                (diagnosticsUpdatedRows === 0
                  ? ""
                  : diagnosticsUpdatedRows < 0
                    ? ", Deleted Rows: " + Math.abs(diagnosticsUpdatedRows)
                    : `, Newly Added Rows: ` + diagnosticsUpdatedRows);
              showMessage("success", diagnosticsSuccessMessage);
              setDeleteDiagnosticsIds([]);
              if (onDone) { onDone(); } else { setSalesReport(); }
            },
            () => {
              setIsActionLoading(false);
            }
          ),
        );
      }
      diagnosticsGridApi.deselectAll();
    } catch (err) {
      setIsActionLoading(false);
      console.log(err.toString());
      diagnosticsGridApi.deselectAll();
      showMessage("error", err.toString());
    }
  };

  const getInvalidRowsFromGrid = (gridApi, checkRow) => {
    if (!gridApi || gridApi.isDestroyed()) return [];
    gridApi.stopEditing();
    let invalidRows = [];
    gridApi.forEachNode((node) => {
      const data = node.data;
      if (!data || isEmpty(data) || checkNullRow(data)) return;
      const { flag, errorKey } = checkRow(data);
      if (flag) {
        invalidRows.push({ rowNumber: node.rowIndex + 1, errors: errorKey });
      }
    });
    return invalidRows;
  };

  const showInvalidRowsSummary = () => {
    // Save covers every tab, so validate every tab that has been opened
    let sections = [
      {
        section: "API",
        errors: getInvalidRowsFromGrid(apiGridApi, checkApiRow),
      },
      {
        section: "FDF",
        errors: getInvalidRowsFromGrid(fdfGridApi, checkFdfRow),
      },
      {
        section: "Diagnostics",
        errors: getInvalidRowsFromGrid(diagnosticsGridApi, checkDiagnosticsRow),
      },
    ];
    sections = sections.filter((val) => val.errors.length > 0);
    if (sections.length === 0) return false;
    const totalRows = sections.reduce((sum, val) => sum + val.errors.length, 0);
    Modal.error({
      title: "Report not saved: invalid rows found",
      width: 560,
      content: (
        <div>
          <p className="mt-10 mb-10">
            <strong>{totalRows}</strong> invalid {totalRows === 1 ? "row" : "rows"} in{" "}
            {sections
              .map((val) => `${val.section} (${val.errors.length})`)
              .join(", ")}
            . Please correct them and save again.
          </p>
          <div style={{ maxHeight: 400, overflowY: "auto" }}>
            {sections.map((sectionError) => (
              <div
                key={sectionError.section}
                style={{
                  border: "1px solid #f0f0f0",
                  borderRadius: 4,
                  marginBottom: 12,
                }}
              >
                <div
                  style={{
                    background: "#fff1f0",
                    padding: "6px 12px",
                    fontWeight: 600,
                  }}
                >
                  {sectionError.section} tab: {sectionError.errors.length} invalid{" "}
                  {sectionError.errors.length === 1 ? "row" : "rows"}
                </div>
                {sectionError.errors.map((rowError) => (
                  <div
                    key={rowError.rowNumber}
                    style={{
                      display: "flex",
                      padding: "6px 12px",
                      borderTop: "1px solid #f0f0f0",
                    }}
                  >
                    <span style={{ width: 70, flexShrink: 0 }}>
                      <strong>Row {rowError.rowNumber}</strong>
                    </span>
                    <span>{rowError.errors.join(", ")}</span>
                  </div>
                ))}
              </div>
            ))}
          </div>
        </div>
      ),
    });
    return true;
  };

  const saveData = () => {
    // Do not call the API while there are invalid rows in any tab
    if (showInvalidRowsSummary()) return;

    const isHistoricAdmin = isUserAdmin && isHistoricQuarter;
    const quarter = isHistoricAdmin ? quarterDropdownCurrent : null;
    const reload = () =>
      isHistoricAdmin
        ? setSalesReport(quarter.replace(/\s+to\s+/, "-"))
        : setSalesReport();

    // Save every opened tab one after another, then reload the report once so
    // unsaved edits in the other tabs are not lost by a per-tab reload
    const steps = [];
    if (apiGridApi && !apiGridApi.isDestroyed()) {
      steps.push((next) => saveApiData(quarter, next));
    }
    if (fdfGridApi && !fdfGridApi.isDestroyed()) {
      steps.push((next) => saveFdfData(quarter, next));
    }
    if (diagnosticsGridApi && !diagnosticsGridApi.isDestroyed()) {
      steps.push((next) => saveDiagnosticsData(quarter, next));
    }
    const run = (index) => {
      if (index >= steps.length) {
        reload();
        return;
      }
      steps[index](() => run(index + 1));
    };
    run(0);
  };

  const saveReportBeforeAction = (callback) => {
    setIsActionLoading(true); // Start loading
    if (apiGridApi) apiGridApi.stopEditing();
    if (isFdfInitialized) fdfGridApi.stopEditing();
    try {
      let apiData =
        ApiRowData && ApiRowData.length > 0
          ? ApiRowData.filter((value) => !isEmpty(value)).map((value) => {
              // Create a deep copy to avoid mutating the original state
              const valueCopy = { ...value };
              const { country_name, product_name } = valueCopy;
              if (
                country_name &&
                countryOrder
                  .map((value) => value.country_name)
                  .includes(country_name)
              ) {
                valueCopy["country_id"] =
                  countryOrder[
                    findIndex(countryOrder, { country_name: country_name })
                  ].country_id;
              }
              if (product_name && apiProductDropdown.includes(product_name)) {
                valueCopy["active_product_id"] =
                  apiProductOrder[
                    findIndex(apiProductOrder, { product_name: product_name })
                  ].active_product_id;
              }
              return valueCopy;
            })
          : [];
      let fdfData =
        FdfRowData && FdfRowData.length > 0
          ? FdfRowData.filter((value) => !isEmpty(value)).map((value) => {
              // Create a deep copy to avoid mutating the original state
              const valueCopy = { ...value };
              const { country_name, product_name } = valueCopy;
              if (
                country_name &&
                countryOrder
                  .map((value) => value.country_name)
                  .includes(country_name)
              ) {
                valueCopy["country_id"] =
                  countryOrder[
                    findIndex(countryOrder, { country_name: country_name })
                  ].country_id;
              }
              if (product_name && fdfProductDropdown.includes(product_name)) {
                valueCopy["active_product_id"] =
                  fdfProductOrder[
                    findIndex(fdfProductOrder, { product_name: product_name })
                  ].active_product_id;
              }
              for (let country of royalty_countries_product) {
                if (country.country_id === valueCopy.country_id) {
                  for (let countryProduct of country.product) {
                    if (
                      (isUserDetails?.is_royalty_partner ||
                        reportDetails?.is_royalty_partner) &&
                      countryProduct.product_name === valueCopy.product_name &&
                      !valueCopy.request_id__mapping_id
                    ) {
                      if (
                        !(
                          reportDetails?.partner_name === "Emcure" &&
                          valueCopy.country_name === "India"
                        )
                      ) {
                        throw Error(
                          "Please fill the request id in FDF section",
                        );
                      }
                    }
                  }
                }
              }
              return valueCopy;
            })
          : [];
      if (checkFdfRowNodes(fdfData) && checkApiRowNodes(apiData)) {
        let finalApiData = apiData.filter((value) => !checkNullRow(value));
        let finalFdfData = fdfData.filter((value) => !checkNullRow(value));
        if (isUserAdmin || isUserDiagnosticAdmin) {
          dispatch(
            postAdminApiSalesData(
              partnerId,
              [...deleteApiIds, ...finalApiData],
              () => {
                setDeleteApiIds([]);
                dispatch(
                  postAdminFdfSalesData(
                    partnerId,
                    [...deleteFdfIds, ...finalFdfData],
                    () => {
                      setDeleteFdfIds([]);
                      setIsActionLoading(false); // Stop loading
                      callback();
                    },
                    () => {
                      // Error callback for FDF
                      setIsActionLoading(false);
                    }
                  ),
                );
              },
              () => {
                // Error callback for API
                setIsActionLoading(false);
              }
            ),
          );
        } else {
          dispatch(
            postApiSalesReportData([...deleteApiIds, ...finalApiData], 
              () => {
                setDeleteApiIds([]);
                dispatch(
                  postFdfSalesReportData(
                    [...deleteFdfIds, ...finalFdfData],
                    () => {
                      setDeleteFdfIds([]);
                      setIsActionLoading(false); // Stop loading
                      callback();
                    },
                    () => {
                      // Error callback for FDF - ADD THIS
                      setIsActionLoading(false);
                    }
                  ),
                );
              },
              () => {
                // Error callback for API - ADD THIS
                setIsActionLoading(false);
              }
            ),
          );
        }
      } else {
        setIsActionLoading(false); // Stop loading on error
      }
    } catch (err) {
      setIsActionLoading(false); // Stop loading on error
      console.log(err.toString());
      showMessage("error", err.toString());
    }
  };

const showSubmitConfirm = () => {
  // First save the data before validation and submission
  saveReportBeforeAction(() => {
    // After saving, validate all data before showing submit confirmation
    let validationErrors = validateDataForSubmission();
    
    if (validationErrors.length > 0) {
      // Show validation errors and prevent submission
      showValidationErrors(validationErrors);
      return;
    }
    
    // If validation passes, show the confirmation modal
    confirm({
      title: "Do you want to submit the report?",
      content: (
        <Spin spinning={isActionLoading}>
          {showCommentsForm()}
        </Spin>
      ),
      className: "btn-confirm-green",
      okText: "Submit",
      cancelText: "Cancel",
      onOk(close) {
        form.validateFields().then((values) => {
          let msg = values.commentData || "";
          setIsActionLoading(true);
          dispatch(
            submitSalesReportData({ message: msg }, () => {
              // Success callback
              setIsActionLoading(false);
              setSalesReport();
              form.resetFields(["commentData"]);
            }, () => {
              // Error callback - ADD THIS
              setIsActionLoading(false);
            }),
          );
          close();
        });
      },
      onCancel() {
        form.resetFields(["commentData"]);
      },
    });
  });
};

  const approver = (msg, isApproved) => {
    setIsActionLoading(true); // Start loading
    let data = {
      partner_id: partnerId,
      message: msg,
      is_approved: isApproved,
    };
    dispatch(
      approveSalesReportData(data, () => {
        setIsActionLoading(false); // Stop loading
        if (isApproved) {
          showMessage("success", "Report Approved!");
        } else {
          showMessage("success", "Report Rejected!");
        }
        form.resetFields(["commentData"]);
        setSalesReport();
      }, () => {
        // Error callback - ADD THIS
        setIsActionLoading(false);
      }),
    );
  };

  const showCommentsForm = () => {
    return (
      <Form form={form} layout="vertical" className="mt-20">
        <div className="mb-10">
          <span>
            {isUserAdmin
              ? "Add comments for partner:"
              : "Add comments for admin:"}
          </span>
        </div>
        <Form.Item name="commentData" className="mb-0">
          <Input.TextArea placeholder="Enter comments here" />
        </Form.Item>
      </Form>
    );
  };

  const showRejectConfirm = () => {
    confirm({
      title: "Do you want to reject the report?",
      className: "btn-confirm-red",
      content: (
        <Spin spinning={isActionLoading}>
          {showCommentsForm()}
        </Spin>
      ),
      okText: "Reject",
      cancelText: "Cancel",
      icon: <CloseCircleOutlined />,
      onOk(close) {
        form.validateFields().then((values) => {
          let msg = values.commentData || "";
          approver(msg, false);
          close();
        });
      },
      onCancel() {
        form.resetFields(["commentData"]);
      },
    });
  };

  const showApproveConfirm = () => {
    confirm({
      title: "Do you want to approve the report?",
      className: "btn-confirm-green",
      content: (
        <Spin spinning={isActionLoading}>
          {showCommentsForm()}
        </Spin>
      ),
      icon: <CheckCircleOutlined />,
      okText: "Approve",
      cancelText: "Cancel",
      onOk(close) {
        form.validateFields().then((values) => {
          let msg = values.commentData || "";
          approver(msg, true);
          close();
        });
      },
      onCancel() {
        form.resetFields(["commentData"]);
      },
    });
  };


  const displayHeader = () => {
    const {
      partner_name,
      quarter_name,
      report_status,
      approval_time,
      submission_time,
    } = reportDetails;
    if (apiProductOrder.length > 0 || fdfProductOrder.length > 0) {
      return (
        <div className={pendingProducts > 0 ? "gx-mb-2" : "gx-mb-4"}>
          <h1 className="title ">
            {isUserAdmin || isUserStaff ? (
              <Tooltip title="Back">
                <LeftOutlined className="mr-10" onClick={navigateBack} />
              </Tooltip>
            ) : null}
            Sales Report{" "}
            {isUserAdmin || isUserStaff ? (
              <span className="mr-5">
                for <span className="text-capitalize">{partner_name}</span>
              </span>
            ) : null}
            <span className="text-capitalize">({quarter_name})</span>
          </h1>
          <h4 className={isUserAdmin || isUserStaff ? "ml-30" : ""}>
            Report Status:
            <span className="text-capitalize"> {" " + report_status}</span>
            <span>
              {!approval_time && !submission_time
                ? ""
                : " on " +
                  moment(
                    report_status === "Submitted" ||
                      report_status === "Resubmitted"
                      ? submission_time
                      : approval_time,
                  ).format("Do MMM YYYY, hh:mm A")}
            </span>
          </h4>
        </div>
      );
    } else {
      return (
        <div className="gx-mb-4">
          <h1 className="title ">
            {isUserAdmin ? (
              <LeftOutlined className="mr-5" onClick={navigateBack} />
            ) : null}
            Sales Report{" "}
            {isUserAdmin && partner_name ? (
              <span>
                for <span className="text-capitalize">{partner_name}</span>
              </span>
            ) : null}
          </h1>
        </div>
      );
    }
  };

  const displayProductVerification = () => {
    if (isUserAdmin && pendingProducts > 0) {
      return (
        <Alert
          className="ml-30 min-width-600"
          message="Product verification pending!"
          description={
            <div>
              <span>
                There are
                <span className="text-capitalize color-red ml-5 mr-5">
                  {" "}
                  {pendingProducts}
                </span>
                products to be verified
                <Button
                  id="view-product-verification"
                  type="link"
                  className="mb-0"
                  onClick={() => viewVerificationModal()}
                >
                  View Details
                </Button>
              </span>
            </div>
          }
          type="warning"
          showIcon
        />
      );
    }
  };

  const displayCTA = () => {
    if (
      apiProductOrder.length > 0 ||
      fdfProductOrder.length > 0 ||
      diagnosticsProductOrder.length > 0
    ) {
      const { report_status } = reportDetails;

      if (isUserAdmin || isUserStaff || isUserDiagnosticAdmin || isUserDiagnosticReviewer) {
        // Admin-style view: Save, Approve, Reject, Download, Mail, Quarter Dropdown
        return (
          <ReportActionButtons
            // Quarter dropdown props
            quarterDropdownCurrent={quarterDropdownCurrent}
            onQuarterChange={changeQuarter}
            quarterDropdown={quarterDropdown}

            // Action button props
            onSave={handleSave}
            onApprove={handleApprove}
            onReject={handleReject}
            onDownload={handleDownload}

            // Permission props
            isUserAdmin={isUserAdmin || isUserDiagnosticAdmin}
            isUserStaff={isUserStaff}
            isHistoricQuarter={isHistoricQuarter}

            // Report status
            reportStatus={report_status}

            // Notification props
            messageCount={messageCount}
            messages={
              apiSalesList && apiSalesList.messages
                ? apiSalesList.messages
                : fdfSalesList && fdfSalesList.messages
                  ? fdfSalesList.messages
                  : []
            }
            onNotificationClick={handleNotificationClick}

            // Disable states
            disableSave={
              isUserDiagnosticReviewer
                ? true
                : isUserAdmin || isUserDiagnosticAdmin
                  ? false
                  : isUserStaff
                    ? true
                    : isHistoricQuarter
                      ? true
                      : report_status === "Approved"
            }
            disableApprove={pendingProducts > 0 || isHistoricQuarter || isUserStaff || isUserDiagnosticReviewer}
            disableReject={pendingProducts > 0 || isHistoricQuarter || isUserStaff || isUserDiagnosticReviewer}

            // Show/hide specific buttons - Admin/Staff configuration
            showSave={true}
            showApprove={true}
            showReject={true}
            showSubmit={false}  // No submit for admin/staff
            showDownload={true}
            showQuarterDropdown={quarterDropdown && quarterDropdown.length > 0}

            // Skip confirmation props
            skipApproveConfirm={true}
            skipRejectConfirm={true}

            // Custom styles
            className="sales-report-actions"
          />
        );
      } else {
        // Partner view: Save, Submit Report, Mail, Download, Quarter Dropdown
        return (
          <ReportActionButtons
            // Quarter dropdown props
            quarterDropdownCurrent={quarterDropdownCurrent}
            onQuarterChange={changeQuarter}
            quarterDropdown={quarterDropdown}

            // Action button props
            onSave={handleSave}
            onSubmit={handleSubmit}
            onDownload={handleDownload}

            // Permission props
            isUserAdmin={isUserAdmin}
            isUserStaff={isUserStaff}
            isHistoricQuarter={isHistoricQuarter}

            // Report status
            reportStatus={report_status}

            // Notification props
            messageCount={messageCount}
            messages={
              apiSalesList && apiSalesList.messages
                ? apiSalesList.messages
                : fdfSalesList && fdfSalesList.messages
                  ? fdfSalesList.messages
                  : []
            }
            onNotificationClick={handleNotificationClick}

            // Disable states
            disableSave={
              isUserDiagnosticReviewer
                ? true
                : isUserAdmin
                  ? false
                  : isUserStaff
                    ? true
                    : isHistoricQuarter
                      ? true
                      : report_status === "Approved"
            }
            disableSubmit={isUserDiagnosticReviewer || (isHistoricQuarter ? true : report_status === "Approved")}

            // Show/hide specific buttons - Partner configuration
            showSave={true}
            showApprove={false}  // No approve for partners
            showReject={false}   // No reject for partners
            showSubmit={true}
            showDownload={true}
            showQuarterDropdown={quarterDropdown && quarterDropdown.length > 0}
            skipSubmitConfirm={true}

            // Custom styles
            className="sales-report-actions"
          />
        );
      }
    } else {
      return null;
    }
  };

const downloadExcel = () => {
if (tabKey === "api" && apiGridApi) {
      apiGridApi.selectAll();
      apiGridApi.exportDataAsExcel({
        sheetName: "API",
        fileName: "sales-report",
        columnKeys: [
          "year",
          "month",
          "country_name",
          "purchaser",
          "product_name",
          "quantity",
          "total_value",
          "comments"
        ],
      });
      apiGridApi.deselectAll();
    } else if (tabKey === "fdf" && fdfGridApi) {
      fdfGridApi.selectAll();
      fdfGridApi.exportDataAsExcel({
        sheetName: "FDF",
        fileName: "sales-report",
        columnKeys: [
          "year",
          "month",
          "country_name",
          "purchaser",
          "product_name",
          "strength",
          "formulation_md",
          "pack_size",
          "quantity",
          "request_id__mapping_id",
          "currency",
          "gross_sale_price_currency",
          "usd_exchange_rate",
          "gross_sale_price_usd",
          "total_gross_value",
          "deductable_expenses",
          "total_value",
          "royalty_percent",
          "royalty_due",
          "procurement_end_country",
          "comments",
        ],
      });
      fdfGridApi.deselectAll();
    } else if (tabKey === "diagnostics" && diagnosticsGridApi) {
      diagnosticsGridApi.selectAll();
      diagnosticsGridApi.exportDataAsExcel({
        sheetName: "Diagnostics",
        fileName: "sales-report",
        columnKeys: [
          "year",
          "month",
          "country_name",
          "purchaser",
          "product_name",
          "pack_size",
          "quantity",
          "currency",
          "gross_sale_price_currency",
          "usd_exchange_rate",
          "gross_sale_price_usd",
          "deductable_expenses",
          "total_value",
          "royalty_percent",
          "royalty_due",
          "procurement_end_country",
          "comments",
        ],
      });
      diagnosticsGridApi.deselectAll();
    }
  };

  const handleApiCellValueChange = (params) => {
    const { colDef, node, newValue, oldValue } = params;
    let rowNode = apiGridApi.getRowNode(node.id);
    if (newValue !== oldValue) {
      switch (colDef.field) {
        case "year":
          if (!isNaN(newValue) && yearDropdown.includes(Number(newValue))) {
            rowNode.setDataValue(colDef.field, Number(newValue));
          } else {
            if (newValue === " ") {
              rowNode.setDataValue(colDef.field, null);
            }
          }
          break;
        case "month":
          if (newValue === " ") {
            rowNode.setDataValue(colDef.field, null);
          }
          break;
        case "country":
          if (newValue === " ") {
            rowNode.setDataValue(colDef.field, null);
          }
          break;
        case "quantity":
          if (!isNaN(newValue)) {
            if (newValue === null) {
              rowNode.setDataValue(colDef.field, 0);
            } else {
              rowNode.setDataValue(colDef.field, Number(newValue));
            }
          } else {
            if (
              newValue &&
              newValue.indexOf(",") !== -1 &&
              !isNaN(newValue.split(",").join(""))
            ) {
              rowNode.setDataValue(
                colDef.field,
                Number(newValue.split(",").join("")),
              );
            }
          }
          break;
        case "total_value":
          if (!isNaN(newValue)) {
            if (newValue === null) {
              rowNode.setDataValue(colDef.field, 0);
            } else {
              rowNode.setDataValue(colDef.field, Number(newValue));
            }
          } else {
            if (
              newValue &&
              newValue.indexOf(",") !== -1 &&
              !isNaN(newValue.split(",").join(""))
            ) {
              rowNode.setDataValue(
                colDef.field,
                Number(newValue.split(",").join("")),
              );
            }
          }
          break;
        default:
          break;
      }
    }
  };

  const handleFdfCellValueChange = (params) => {
    const { colDef, node, newValue, oldValue } = params;
    let rowNode = fdfGridApi.getRowNode(node.id);
    if (newValue !== oldValue) {
      switch (colDef.field) {
        case "year":
          if (!isNaN(newValue) && yearDropdown.includes(Number(newValue))) {
            rowNode.setDataValue(colDef.field, Number(newValue));
          } else {
            if (newValue === " ") {
              rowNode.setDataValue(colDef.field, null);
            }
          }
          break;
        case "month":
          if (newValue === " ") {
            rowNode.setDataValue(colDef.field, null);
          }
          break;
        case "country":
          if (newValue === " ") {
            rowNode.setDataValue(colDef.field, null);
          }
          break;
        case "formulation_md":
          if (newValue === " ") {
            rowNode.setDataValue(colDef.field, null);
          }
          break;
        case "currency":
          if (newValue === " ") {
            rowNode.setDataValue(colDef.field, null);
          }
          break;
        case "quantity":
          if (!isNaN(newValue)) {
            if (newValue === null) {
              rowNode.setDataValue(colDef.field, 0);
            } else {
              rowNode.setDataValue(colDef.field, Number(newValue));
            }
          } else {
            if (
              newValue &&
              newValue.indexOf(",") !== -1 &&
              !isNaN(newValue.split(",").join(""))
            ) {
              rowNode.setDataValue(
                colDef.field,
                Number(newValue.split(",").join("")),
              );
            }
          }
          break;
        case "pack_size":
          if (!isNaN(newValue)) {
            if (newValue === null) {
              rowNode.setDataValue(colDef.field, 0);
            } else {
              rowNode.setDataValue(colDef.field, Number(newValue));
            }
          } else {
            if (
              newValue &&
              newValue.indexOf(",") !== -1 &&
              !isNaN(newValue.split(",").join(""))
            ) {
              rowNode.setDataValue(
                colDef.field,
                Number(newValue.split(",").join("")),
              );
            }
          }
          break;
        case "gross_sale_price_currency":
          if (!isNaN(newValue)) {
            if (newValue === null) {
              rowNode.setDataValue(colDef.field, 0);
            } else {
              rowNode.setDataValue(colDef.field, Number(newValue));
            }
          } else {
            if (
              newValue &&
              newValue.indexOf(",") !== -1 &&
              !isNaN(newValue.split(",").join(""))
            ) {
              rowNode.setDataValue(
                colDef.field,
                Number(newValue.split(",").join("")),
              );
            }
          }
          break;
        case "usd_exchange_rate":
          if (!isNaN(newValue)) {
            if (newValue === null) {
              rowNode.setDataValue(colDef.field, 0);
            } else {
              rowNode.setDataValue(colDef.field, Number(newValue));
            }
          } else {
            if (
              newValue &&
              newValue.indexOf(",") !== -1 &&
              !isNaN(newValue.split(",").join(""))
            ) {
              rowNode.setDataValue(
                colDef.field,
                Number(newValue.split(",").join("")),
              );
            }
          }
          break;
        case "gross_sale_price_usd":
          if (!isNaN(newValue)) {
            if (newValue === null) {
              rowNode.setDataValue(colDef.field, 0);
            } else {
              rowNode.setDataValue(colDef.field, Number(newValue));
            }
          } else {
            if (
              newValue &&
              newValue.indexOf(",") !== -1 &&
              !isNaN(newValue.split(",").join(""))
            ) {
              rowNode.setDataValue(
                colDef.field,
                Number(newValue.split(",").join("")),
              );
            }
          }
          break;
        case "total_gross_value":
          if (!isNaN(newValue)) {
            if (newValue === null) {
              rowNode.setDataValue(colDef.field, 0);
            } else {
              rowNode.setDataValue(colDef.field, Number(newValue));
            }
          } else {
            if (
              newValue &&
              newValue.indexOf(",") !== -1 &&
              !isNaN(newValue.split(",").join(""))
            ) {
              rowNode.setDataValue(
                colDef.field,
                Number(newValue.split(",").join("")),
              );
            }
          }
          break;
        case "deductable_expenses":
          if (!isNaN(newValue)) {
            if (newValue === null) {
              rowNode.setDataValue(colDef.field, 0);
            } else {
              rowNode.setDataValue(colDef.field, Number(newValue));
            }
          } else {
            if (
              newValue &&
              newValue.indexOf(",") !== -1 &&
              !isNaN(newValue.split(",").join(""))
            ) {
              rowNode.setDataValue(
                colDef.field,
                Number(newValue.split(",").join("")),
              );
            }
          }
          break;
        case "total_value":
          if (!isNaN(newValue)) {
            if (newValue === null) {
              rowNode.setDataValue(colDef.field, 0);
            } else {
              rowNode.setDataValue(colDef.field, Number(newValue));
            }
          } else {
            if (
              newValue &&
              newValue.indexOf(",") !== -1 &&
              !isNaN(newValue.split(",").join(""))
            ) {
              rowNode.setDataValue(
                colDef.field,
                Number(newValue.split(",").join("")),
              );
            }
          }
          break;
        case "royalty_percent":
          if (!isNaN(newValue)) {
            if (newValue === null) {
              rowNode.setDataValue(colDef.field, 0);
            } else {
              rowNode.setDataValue(colDef.field, Number(newValue));
            }
          } else {
            if (
              newValue &&
              newValue.indexOf(",") !== -1 &&
              !isNaN(newValue.split(",").join(""))
            ) {
              rowNode.setDataValue(
                colDef.field,
                Number(newValue.split(",").join("")),
              );
            }
          }
          break;
        case "royalty_due":
          if (!isNaN(newValue)) {
            if (newValue === null) {
              rowNode.setDataValue(colDef.field, 0);
            } else {
              rowNode.setDataValue(colDef.field, Number(newValue));
            }
          } else {
            if (
              newValue &&
              newValue.indexOf(",") !== -1 &&
              !isNaN(newValue.split(",").join(""))
            ) {
              rowNode.setDataValue(
                colDef.field,
                Number(newValue.split(",").join("")),
              );
            }
          }
          break;
        default:
          break;
      }
    }
  };

  const handleApiRowSelection = () => {
    if (apiGridApi) {
      setAreApiRowsSelected(apiGridApi.getSelectedNodes().length > 0);
    }
  };

  const handleFdfRowSelection = () => {
    if (fdfGridApi) {
      setAreFdfRowsSelected(fdfGridApi.getSelectedNodes().length > 0);
    }
  };

  const handleDiagnosticsRowSelection = () => {
    if (diagnosticsGridApi) {
      setAreDiagnosticsRowsSelected(diagnosticsGridApi.getSelectedNodes().length > 0);
    }
  };

  const deleteSelectedApiRows = () => {
    if (!apiGridApi) {
      console.warn('API Grid not initialized yet');
      return;
    }

    let rowIndexList = apiGridApi
      .getSelectedNodes()
      .map((value) => Number(value.id));
    let tempDeleteIds = [...deleteApiIds];
    let rowData = [...ApiRowData];
    rowIndexList.forEach((value) => {
      let nodeData = apiGridApi.getRowNode(value);
      if (
        Object.prototype.hasOwnProperty.call(
          nodeData.data,
          "sales_report_id",
        ) &&
        !has(tempDeleteIds, { sales_report_id: nodeData.data.sales_report_id })
      ) {
        tempDeleteIds.push({ sales_report_id: nodeData.data.sales_report_id });
      }
    });

    let finalData = rowData.filter((value, index) => {
      return !rowIndexList.includes(index);
    });
    setApiRowData(finalData);
    setDeleteApiIds(tempDeleteIds);
    apiGridApi.deselectAll();
  };

  const deleteSelectedFdfRows = () => {
    if (!fdfGridApi) {
      console.warn('FDF Grid not initialized yet');
      return;
    }

    let rowIndexList = fdfGridApi
      .getSelectedNodes()
      .map((value) => value.rowIndex);
    let tempDeleteIds = [...deleteApiIds];
    let rowData = [...FdfRowData];
    rowIndexList.forEach((value) => {
      let nodeData = fdfGridApi.getRowNode(value);
      if (
        Object.prototype.hasOwnProperty.call(
          nodeData.data,
          "sales_report_id",
        ) &&
        !has(tempDeleteIds, { sales_report_id: nodeData.data.sales_report_id })
      ) {
        tempDeleteIds.push({ sales_report_id: nodeData.data.sales_report_id });
      }
    });

    let finalData = rowData.filter((value, index) => {
      return !rowIndexList.includes(index);
    });
    setFdfRowData(finalData);
    setDeleteFdfIds(tempDeleteIds);
    fdfGridApi.deselectAll();
  };

  const handleDiagnosticsCellValueChange = (params) => {
    const { colDef, node, newValue, oldValue } = params;
    let rowNode = diagnosticsGridApi.getRowNode(node.id);
    if (newValue !== oldValue) {
      switch (colDef.field) {
        case "year":
          if (!isNaN(newValue) && yearDropdown.includes(Number(newValue))) {
            rowNode.setDataValue(colDef.field, Number(newValue));
          } else {
            if (newValue === " ") {
              rowNode.setDataValue(colDef.field, null);
            }
          }
          break;
        case "month":
          if (newValue === " ") {
            rowNode.setDataValue(colDef.field, null);
          }
          break;
        case "country":
          if (newValue === " ") {
            rowNode.setDataValue(colDef.field, null);
          }
          break;
        case "currency":
          if (newValue === " ") {
            rowNode.setDataValue(colDef.field, null);
          }
          break;
        case "quantity":
          if (!isNaN(newValue)) {
            if (newValue === null) {
              rowNode.setDataValue(colDef.field, 0);
            } else {
              rowNode.setDataValue(colDef.field, Number(newValue));
            }
          } else {
            if (
              newValue &&
              newValue.indexOf(",") !== -1 &&
              !isNaN(newValue.split(",").join(""))
            ) {
              rowNode.setDataValue(
                colDef.field,
                Number(newValue.split(",").join("")),
              );
            }
          }
          break;
        case "pack_size":
          if (!isNaN(newValue)) {
            if (newValue === null) {
              rowNode.setDataValue(colDef.field, 0);
            } else {
              rowNode.setDataValue(colDef.field, Number(newValue));
            }
          } else {
            if (
              newValue &&
              newValue.indexOf(",") !== -1 &&
              !isNaN(newValue.split(",").join(""))
            ) {
              rowNode.setDataValue(
                colDef.field,
                Number(newValue.split(",").join("")),
              );
            }
          }
          break;
        case "gross_sale_price_currency":
          if (!isNaN(newValue)) {
            if (newValue === null) {
              rowNode.setDataValue(colDef.field, 0);
            } else {
              rowNode.setDataValue(colDef.field, Number(newValue));
            }
          } else {
            if (
              newValue &&
              newValue.indexOf(",") !== -1 &&
              !isNaN(newValue.split(",").join(""))
            ) {
              rowNode.setDataValue(
                colDef.field,
                Number(newValue.split(",").join("")),
              );
            }
          }
          break;
        case "usd_exchange_rate":
          if (!isNaN(newValue)) {
            if (newValue === null) {
              rowNode.setDataValue(colDef.field, 0);
            } else {
              rowNode.setDataValue(colDef.field, Number(newValue));
            }
          } else {
            if (
              newValue &&
              newValue.indexOf(",") !== -1 &&
              !isNaN(newValue.split(",").join(""))
            ) {
              rowNode.setDataValue(
                colDef.field,
                Number(newValue.split(",").join("")),
              );
            }
          }
          break;
        case "gross_sale_price_usd":
          if (!isNaN(newValue)) {
            if (newValue === null) {
              rowNode.setDataValue(colDef.field, 0);
            } else {
              rowNode.setDataValue(colDef.field, Number(newValue));
            }
          } else {
            if (
              newValue &&
              newValue.indexOf(",") !== -1 &&
              !isNaN(newValue.split(",").join(""))
            ) {
              rowNode.setDataValue(
                colDef.field,
                Number(newValue.split(",").join("")),
              );
            }
          }
          break;
        case "deductable_expenses":
          if (!isNaN(newValue)) {
            if (newValue === null) {
              rowNode.setDataValue(colDef.field, 0);
            } else {
              rowNode.setDataValue(colDef.field, Number(newValue));
            }
          } else {
            if (
              newValue &&
              newValue.indexOf(",") !== -1 &&
              !isNaN(newValue.split(",").join(""))
            ) {
              rowNode.setDataValue(
                colDef.field,
                Number(newValue.split(",").join("")),
              );
            }
          }
          break;
        case "total_value":
          if (!isNaN(newValue)) {
            if (newValue === null) {
              rowNode.setDataValue(colDef.field, 0);
            } else {
              rowNode.setDataValue(colDef.field, Number(newValue));
            }
          } else {
            if (
              newValue &&
              newValue.indexOf(",") !== -1 &&
              !isNaN(newValue.split(",").join(""))
            ) {
              rowNode.setDataValue(
                colDef.field,
                Number(newValue.split(",").join("")),
              );
            }
          }
          break;
        case "royalty_percent":
          if (!isNaN(newValue)) {
            if (newValue === null) {
              rowNode.setDataValue(colDef.field, 0);
            } else {
              rowNode.setDataValue(colDef.field, Number(newValue));
            }
          } else {
            if (
              newValue &&
              newValue.indexOf(",") !== -1 &&
              !isNaN(newValue.split(",").join(""))
            ) {
              rowNode.setDataValue(
                colDef.field,
                Number(newValue.split(",").join("")),
              );
            }
          }
          break;
        case "royalty_due":
          if (!isNaN(newValue)) {
            if (newValue === null) {
              rowNode.setDataValue(colDef.field, 0);
            } else {
              rowNode.setDataValue(colDef.field, Number(newValue));
            }
          } else {
            if (
              newValue &&
              newValue.indexOf(",") !== -1 &&
              !isNaN(newValue.split(",").join(""))
            ) {
              rowNode.setDataValue(
                colDef.field,
                Number(newValue.split(",").join("")),
              );
            }
          }
          break;
        default:
          break;
      }
    }
  };

  const deleteSelectedDiagnosticsRows = () => {
    if (!diagnosticsGridApi) {
      console.warn('Diagnostics Grid not initialized yet');
      return;
    }

    let rowIndexList = diagnosticsGridApi
      .getSelectedNodes()
      .map((value) => value.rowIndex);
    let tempDeleteIds = [...deleteDiagnosticsIds];
    let rowData = [...DiagnosticsRowData];
    rowIndexList.forEach((value) => {
      let nodeData = diagnosticsGridApi.getRowNode(value);
      if (
        Object.prototype.hasOwnProperty.call(
          nodeData.data,
          "sales_report_id",
        ) &&
        !has(tempDeleteIds, { sales_report_id: nodeData.data.sales_report_id })
      ) {
        tempDeleteIds.push({ sales_report_id: nodeData.data.sales_report_id });
      }
    });

    let finalData = rowData.filter((value, index) => {
      return !rowIndexList.includes(index);
    });
    setDiagnosticsRowData(finalData);
    setDeleteDiagnosticsIds(tempDeleteIds);
    diagnosticsGridApi.deselectAll();
  };

  const setReportHeight = () => {
    return window.innerHeight - 230;
  };

  // Action handlers for ReportActionButtons
  const handleSave = () => {
    saveData();
  };

  const handleApprove = () => {
    showApproveConfirm();
  };

  const handleReject = () => {
    showRejectConfirm();
  };

  const handleSubmit = () => {
    showSubmitConfirm();
  };

  const handleDownload = () => {
    downloadExcel();
  };

  const handleNotificationClick = () => {
    dispatch(
      partnerMarkSalesReportMessageRead(
        isUserAdmin ? "admin" : "partner",
        () => setMessageCount(0),
      ),
    );
  };

  const viewVerificationModal = () => {
    dispatch(
      getAdminProductsToBeVerified(partnerId, () => {
        setShowVerificationModal(true);
      }),
    );
  };

  return (
    <div>
      {isLoading ? (
        <div>
          <LoadingBar />
        </div>
      ) : (
        <>
          <Spin spinning={isActionLoading} tip="Processing...">
            <div className="gx-flex-row gx-justify-content-between">
              {displayHeader()}
              {displayCTA()}
            </div>
            <div className="gx-flex-row gx-justify-content-between">
              {displayProductVerification()}
            </div>

            <Tabs
              tabPosition="top"
              type="card"
              className="sales-report-tabs"
              activeKey={tabKey}
              onChange={(currentTabKey) => {
                setTabKey(currentTabKey);
              }}
            >
              {showApiTab && (
              <TabPane tab="API" key="api">
                {apiProductDropdown && apiProductDropdown.length ? (
                  <div>
                    <div
                      className="ag-theme-balham ag-scroll-bar-fix"
                      style={{ height: setReportHeight(), paddingBottom: 20 }}
                    >
                      <AgGridReact
                        onGridReady={onApiGridReady}
                        columnDefs={ApiColumnDefs}
                        rowData={ApiRowData}
                        defaultColGroupDef={{ marryChildren: true }}
                        defaultColDef={{
                          filter: true,
                          sortable: true,
                          width: 300,
                          resizable: true,
                          editable: (params) => {
                            if (
                              isUserAdmin &&
                              params.api.isHistoricQuarter !== true
                            ) {
                              return true;
                            } else if (
                              !isUserStaff &&
                              apiSalesList.sales_meta.report_status !== "Approved" &&
                              params.api.isHistoricQuarter !== true
                            ) {
                              return true;
                            } else {
                              if (Object.keys(params.data).length > 0) {
                                return true;
                              }
                              return false;
                            }
                          },
                          cellClassRules: {
                            "non-editable-cell": (params) => {
                              const { isHistoricQuarter } = params.api;
                              if (
                                !isUserAdmin &&
                                apiSalesList.sales_meta.report_status ===
                                  "Approved" &&
                                !params.value
                              ) {
                                return true;
                              } else if (
                                !isUserAdmin &&
                                isHistoricQuarter &&
                                !params.value
                              ) {
                                return true;
                              } else if (
                                isUserAdmin &&
                                params.api.isHistoricQuarter === true &&
                                !params.value
                              ) {
                                return true;
                              } else if (isUserStaff && !params.value) {
                                return true;
                              } else {
                                return false;
                              }
                            },
                          },
                        }}
                        enableRangeSelection={true}
                        enableCellChangeFlash={true}
                        animateRows={true}
                        rowSelection={"multiple"}
                        suppressRowClickSelection={true}
                        onSelectionChanged={handleApiRowSelection}
                        onCellEditingStarted={(params) => {
                          if (isUserDiagnosticReviewer) {
                            params.api.stopEditing(true);
                          }
                        }}
                        onCellValueChanged={handleApiCellValueChange}
                        components={{
                          searchSelector: SearchSelect,
                          countrySelector: CountrySelect,
                        }}
                      />
                    </div>
                    <div className="gx-flex-row">
                      <InputNumber
                        disabled={
                          isUserAdmin
                            ? false
                            : isHistoricQuarter
                              ? true
                              : reportDetails.report_status === "Approved"
                        }
                        min={0}
                        defaultValue={0}
                        max={10000}
                        onChange={(value) => {
                          setAddApiRowNumber(value);
                        }}
                      />
                      <Button
                        type="primary"
                        onClick={addApiRow}
                        disabled={
                          isUserAdmin
                            ? false
                            : isUserStaff
                              ? true
                              : isHistoricQuarter
                                ? true
                                : reportDetails.report_status === "Approved"
                        }
                      >
                        {" "}
                        Add Row
                      </Button>
                      <Button
                        onClick={deleteSelectedApiRows}
                        disabled={
                          (isUserAdmin
                            ? false
                            : isUserStaff
                              ? true
                              : isHistoricQuarter
                                ? true
                                : reportDetails.report_status === "Approved") ||
                          !areApiRowsSelected
                        }
                      >
                        {" "}
                        Delete Selected Rows
                      </Button>
                    </div>
                  </div>
                ) : null}
              </TabPane>
              )}
              {showFdfTab && (
              <TabPane tab="FDF" key="fdf">
                {fdfProductDropdown && fdfProductDropdown.length ? (
                  <div>
                    <div
                      className="ag-theme-balham ag-scroll-bar-fix"
                      style={{ height: setReportHeight(), paddingBottom: 20 }}
                    >
                      <AgGridReact
                        onGridReady={onFdfGridReady}
                        columnDefs={FdfColumnDefs}
                        rowData={FdfRowData}
                        defaultColGroupDef={{ marryChildren: true }}
                        defaultColDef={{
                          filter: true,
                          sortable: true,
                          width: 300,
                          resizable: true,
                          editable: (params) => {
                            if (
                              isUserAdmin &&
                              params.api.isHistoricQuarter !== true
                            ) {
                              return true;
                            } else if (
                              !isUserStaff &&
                              apiSalesList.sales_meta.report_status !== "Approved" &&
                              params.api.isHistoricQuarter !== true
                            ) {
                              return true;
                            } else {
                              if (Object.keys(params.data).length > 0) {
                                return true;
                              }
                              return false;
                            }
                          },
                          cellClassRules: {
                            "non-editable-cell": (params) => {
                              const { isHistoricQuarter } = params.api;
                              if (
                                !isUserAdmin &&
                                apiSalesList.sales_meta.report_status ===
                                  "Approved" &&
                                !params.value
                              ) {
                                return true;
                              } else if (
                                !isUserAdmin &&
                                isHistoricQuarter &&
                                !params.value
                              ) {
                                return true;
                              } else if (
                                isUserAdmin &&
                                params.api.isHistoricQuarter === true &&
                                !params.value
                              ) {
                                return true;
                              } else if (isUserStaff && !params.value) {
                                return true;
                              } else {
                                return false;
                              }
                            },
                          },
                        }}
                        enableRangeSelection={true}
                        suppressAggFuncInHeader={true}
                        enableCellChangeFlash={true}
                        animateRows={true}
                        rowSelection={"multiple"}
                        suppressRowClickSelection={true}
                        onSelectionChanged={handleFdfRowSelection}
                        onCellEditingStarted={(params) => {
                          if (isUserDiagnosticReviewer) {
                            params.api.stopEditing(true);
                          }
                        }}
                        onCellValueChanged={handleFdfCellValueChange}
                        components={{
                          searchSelector: SearchSelect,
                          countrySelector: CountrySelect,
                          productSelector: ProductSelect,
                        }}
                      />
                    </div>
                    <div className="gx-flex-row">
                      <InputNumber
                        disabled={
                          isUserAdmin
                            ? false
                            : isHistoricQuarter
                              ? true
                              : reportDetails.report_status === "Approved"
                        }
                        min={0}
                        defaultValue={0}
                        max={10000}
                        onChange={(value) => {
                          setAddFdfRowNumber(value);
                        }}
                      />
                      <Button
                        type="primary"
                        onClick={addFdfRow}
                        disabled={
                          isUserAdmin
                            ? false
                            : isUserStaff
                              ? true
                              : isHistoricQuarter
                                ? true
                                : reportDetails.report_status === "Approved"
                        }
                      >
                        {" "}
                        Add Row
                      </Button>
                      <Button
                        onClick={deleteSelectedFdfRows}
                        disabled={
                          (isUserAdmin
                            ? false
                            : isUserStaff
                              ? true
                              : isHistoricQuarter
                                ? true
                                : reportDetails.report_status === "Approved") ||
                          !areFdfRowsSelected
                        }
                      >
                        {" "}
                        Delete Selected Rows
                      </Button>
                    </div>
                  </div>
                ) : null}
              </TabPane>
              )}
              {showDiagnosticsTab && (
              <TabPane tab="Diagnostics" key="diagnostics">
                {diagnosticsProductDropdown ? (
                  <div>
                    <div
                      className="ag-theme-balham ag-scroll-bar-fix"
                      style={{ height: setReportHeight(), paddingBottom: 20 }}
                    >
                      <AgGridReact
                        onGridReady={onDiagnosticsGridReady}
                        columnDefs={DiagnosticsColumnDefs}
                        rowData={DiagnosticsRowData}
                        defaultColGroupDef={{ marryChildren: true }}
                        defaultColDef={{
                          filter: true,
                          sortable: true,
                          width: 300,
                          resizable: true,
                          editable: (params) => {
                            if (
                              isUserAdmin &&
                              params.api.isHistoricQuarter !== true
                            ) {
                              return true;
                            } else if (
                              !isUserStaff &&
                              apiSalesList.sales_meta.report_status !== "Approved" &&
                              params.api.isHistoricQuarter !== true
                            ) {
                              return true;
                            } else {
                              if (Object.keys(params.data).length > 0) {
                                return true;
                              }
                              return false;
                            }
                          },
                          cellClassRules: {
                            "non-editable-cell": (params) => {
                              const { isHistoricQuarter } = params.api;
                              if (
                                !isUserAdmin &&
                                apiSalesList.sales_meta.report_status ===
                                  "Approved" &&
                                !params.value
                              ) {
                                return true;
                              } else if (
                                !isUserAdmin &&
                                isHistoricQuarter &&
                                !params.value
                              ) {
                                return true;
                              } else if (
                                isUserAdmin &&
                                params.api.isHistoricQuarter === true &&
                                !params.value
                              ) {
                                return true;
                              } else if (isUserStaff && !params.value) {
                                return true;
                              } else {
                                return false;
                              }
                            },
                          },
                        }}
                        enableRangeSelection={true}
                        suppressAggFuncInHeader={true}
                        enableCellChangeFlash={true}
                        animateRows={true}
                        rowSelection={"multiple"}
                        suppressRowClickSelection={true}
                        onSelectionChanged={handleDiagnosticsRowSelection}
                        onCellEditingStarted={(params) => {
                          if (isUserDiagnosticReviewer) {
                            params.api.stopEditing(true);
                          }
                        }}
                        onCellValueChanged={handleDiagnosticsCellValueChange}
                        components={{
                          searchSelector: SearchSelect,
                          countrySelector: CountrySelect,
                          productSelector: ProductSelect,
                        }}
                      />
                    </div>
                    <div className="gx-flex-row">
                      <InputNumber
                        disabled={
                          isUserAdmin
                            ? false
                            : isHistoricQuarter
                              ? true
                              : reportDetails.report_status === "Approved"
                        }
                        min={0}
                        defaultValue={0}
                        max={10000}
                        onChange={(value) => {
                          setAddDiagnosticsRowNumber(value);
                        }}
                      />
                      <Button
                        type="primary"
                        onClick={addDiagnosticsRow}
                        disabled={
                          isUserAdmin
                            ? false
                            : isUserStaff
                              ? true
                              : isHistoricQuarter
                                ? true
                                : reportDetails.report_status === "Approved"
                        }
                      >
                        {" "}
                        Add Row
                      </Button>
                      <Button
                        onClick={deleteSelectedDiagnosticsRows}
                        disabled={
                          (isUserAdmin
                            ? false
                            : isUserStaff
                              ? true
                              : isHistoricQuarter
                                ? true
                                : reportDetails.report_status === "Approved") ||
                          !areDiagnosticsRowsSelected
                        }
                      >
                        {" "}
                        Delete Selected Rows
                      </Button>
                    </div>
                  </div>
                ) : null}
              </TabPane>
              )}
            </Tabs>

            {showVerificationModal ? (
              <ProductVerificationModal
                visible={showVerificationModal}
                displayVerificationModal={() => {
                  setShowVerificationModal(true);
                }}
                hideVerificationModal={() => {
                  setShowVerificationModal(false);
                }}
                partnerId={partnerId}
                setSalesReport={setSalesReport}
                statusArray={statusArray}
                quarter_name={quarterDropdownCurrent}
              />
            ) : null}
          </Spin>
        </>
      )}
    </div>
  );
};

export default SalesReport;
